rp.chat.LayerChatModuleV2 = function() {

    // js-cookie v2.2.1 - https://github.com/js-cookie/js-cookie
    !function(a){var b;if("function"==typeof define&&define.amd&&(define(a),b=!0),"object"==typeof exports&&(module.exports=a(),b=!0),!b){var c=window.Cookies,d=window.Cookies=a();d.noConflict=function(){return window.Cookies=c,d}}}(function(){function a(){for(var a=0,b={};a<arguments.length;a++){var c=arguments[a];for(var d in c)b[d]=c[d]}return b}function b(a){return a.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}function c(d){function e(){}function f(b,c,f){if("undefined"!=typeof document){f=a({path:"/"},e.defaults,f),"number"==typeof f.expires&&(f.expires=new Date(1*new Date+864e5*f.expires)),f.expires=f.expires?f.expires.toUTCString():"";try{var g=JSON.stringify(c);/^[\{\[]/.test(g)&&(c=g)}catch(j){}c=d.write?d.write(c,b):encodeURIComponent(c+"").replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),b=encodeURIComponent(b+"").replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var h="";for(var i in f)f[i]&&(h+="; "+i,!0!==f[i]&&(h+="="+f[i].split(";")[0]));return document.cookie=b+"="+c+h}}function g(a,c){if("undefined"!=typeof document){for(var e={},f=document.cookie?document.cookie.split("; "):[],g=0;g<f.length;g++){var h=f[g].split("="),i=h.slice(1).join("=");c||'"'!==i.charAt(0)||(i=i.slice(1,-1));try{var j=b(h[0]);if(i=(d.read||d)(i,j)||b(i),c)try{i=JSON.parse(i)}catch(k){}if(e[j]=i,a===j)break}catch(k){}}return a?e[a]:e}}return e.set=f,e.get=function(a){return g(a,!1)},e.getJSON=function(a){return g(a,!0)},e.remove=function(b,c){f(b,"",a(c,{expires:-1}))},e.defaults={},e.withConverter=c,e}return c(function(){})});
    // dateFormat - http://blog.stevenlevithan.com/archives/date-time-format
    const dateFormat=function(){var t=/d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,e=/\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,a=/[^-+\dA-Z]/g,m=function(t,e){for(t=String(t),e=e||2;t.length<e;)t="0"+t;return t};return function(d,n,r){var y=dateFormat;if(1!=arguments.length||"[object String]"!=Object.prototype.toString.call(d)||/\d/.test(d)||(n=d,d=void 0),d=d?new Date(d):new Date,isNaN(d))throw SyntaxError("invalid date");"UTC:"==(n=String(y.masks[n]||n||y.masks.default)).slice(0,4)&&(n=n.slice(4),r=!0);var s=r?"getUTC":"get",i=d[s+"Date"](),o=d[s+"Day"](),u=d[s+"Month"](),M=d[s+"FullYear"](),l=d[s+"Hours"](),T=d[s+"Minutes"](),h=d[s+"Seconds"](),c=d[s+"Milliseconds"](),g=r?0:d.getTimezoneOffset(),S={d:i,dd:m(i),ddd:y.i18n.dayNames[o],dddd:y.i18n.dayNames[o+7],m:u+1,mm:m(u+1),mmm:y.i18n.monthNames[u],mmmm:y.i18n.monthNames[u+12],yy:String(M).slice(2),yyyy:M,h:l%12||12,hh:m(l%12||12),H:l,HH:m(l),M:T,MM:m(T),s:h,ss:m(h),l:m(c,3),L:m(c>99?Math.round(c/10):c),t:l<12?"a":"p",tt:l<12?"am":"pm",T:l<12?"A":"P",TT:l<12?"AM":"PM",Z:r?"UTC":(String(d).match(e)||[""]).pop().replace(a,""),o:(g>0?"-":"+")+m(100*Math.floor(Math.abs(g)/60)+Math.abs(g)%60,4),S:["th","st","nd","rd"][i%10>3?0:(i%100-i%10!=10)*i%10]};return n.replace(t,function(t){return t in S?S[t]:t.slice(1,t.length-1)})}}();dateFormat.masks={default:"ddd mmm dd yyyy HH:MM:ss",shortDate:"m/d/yy",mediumDate:"mmm d, yyyy",longDate:"mmmm d, yyyy",fullDate:"dddd, mmmm d, yyyy",shortTime:"h:MM TT",mediumTime:"h:MM:ss TT",longTime:"h:MM:ss TT Z",isoDate:"yyyy-mm-dd",isoTime:"HH:MM:ss",isoDateTime:"yyyy-mm-dd'T'HH:MM:ss",isoUtcDateTime:"UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"},dateFormat.i18n={dayNames:["Sun","Mon","Tue","Wed","Thu","Fri","Sat","Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],monthNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec","January","February","March","April","May","June","July","August","September","October","November","December"]},Date.prototype.format=function(t,e){return dateFormat(this,t,e)};

    {
        const RETRY_DELIVER_CHAT_MESSAGE_MS = 2000;
        const MAX_TIME_TO_DELIVER_A_MESSAGE = 200000; // must be higher than '$CHAT_TIMEOUT_MOBILE'

        const layerChatTop = (rp.chat.Core.getConfig().position !== undefined) ? rp.chat.Core.getConfig().position.top : 0;
        const layerChatLeft = ( rp.chat.Core.getConfig().position !== undefined) ? rp.chat.Core.getConfig().position.left : 0;

        let _browserHeight = rp.chat.Core.getBrowserHeight();
        let _browserWidth = rp.chat.Core.getBrowserWidth();

        let _invitetype = 0;

        const _core = rp.chat.Core;
        const domHelper = rp.chat.DOM;
        const cleanHtml = rp.chat.HtmlSanitizer.clean;
        const versionizeUrl = rp.chat.Core.versionizeUrl;
        const networkHelper = rp.chat.Network;
        const _chatWrapperId = 'realpersonChatWrapper';
        let _chatWrapper;
        let _chatWrapperWidth;
        let _chatWrapperHeight;
        const _chatCloseButton = domHelper('#rp-chat-minimize-button');
        let _deptId = rp.chat.Core.getDeptId();
        const _head = domHelper('head');
        const _body = domHelper('body');
        let _visitorId = escape(rp.chat.Core.getSessionRp());
        const _config = rp.chat.Core.getConfig();
        const _dialogUrl = rp.chat.Core.getRPDomain('dialog');
        const _collectUrl = rp.chat.Core.getRPDomain();
        const _cookieName = 'rp-layerchat';
        const _cookieContent = {
            'window': 'prechat',
            'left': layerChatLeft,
            'top': layerChatTop,
            'minimized': false,
            'closed': true,
            'chat-id': 0,
            'dept-id': 0,
            'unread': 0,
            'asked-questions': [],
            'skip-postchat': true,
            'agentLeft': 0,
            'saveTranscript': 1,
            'initialUrl': '',
            'useTranslation': 0,
        };
        const _sectionTag = 'section';
        const _prechatFormId = 'form-prechat';
        const _emailFormId = 'form-email';
        const _chatFormId = 'form-chat';
        const _postchatFormId = 'form-postchat';
        const _snippingBuffer = 20;
        const _snippingBufferBottom = 0;
        const _snippingBufferTop = (rp.chat.Core.getConfig().position !== undefined && rp.chat.Core.getConfig().position.bufferTop !== undefined) ? rp.chat.Core.getConfig().position.bufferTop : _snippingBuffer;
        let _cookies;
        let _sectionActive;
        let _uploader;
        let _businessRuleId;
        let _socket;
        const _socketServerUrl = versionizeUrl(_dialogUrl + '/../socket/socket.io/socket.io.js');
        let _clientChat;
        let _pingTimer;
        const _pingTimerTimeout = 10000;
        let _agentDisconnectedTimer;
        const _agentDisconnectedTimeout = 30000;
        let _typingTimeout;
        let _agentLeft;
        let _chatEnd;
        let _customerName;
        let _requestId;
        let _agentIdentity;
        let _isRunning;
         let _isReconnecting;
        let _reloadChatContent = false;
        const _fadeInTime = 400;
        const _fadeOutTime = 200;
        const _chatLineHeight = 32;
        let _statusButtonUsed = false;
        let _isRouting = false;
        let _isPostChatSubmitted = false;
        let _usedQuickReplyAction;
        let _ignoreBot = false;
        let _handoverOldChat = {};
        let _handoverInitiated = false;
        let _isBot = false;
        let firstPositionSet = false;
        let dataStoreToSocket = [];
        const that = this;
        let _operatorMessageTimeouts = [];
        let delayRoutingWindowTimeout;
        let lastContentView = '';
        let lastContentViewCounter = 0;
        let botSearchReply = {};

        this.loadDepencies = function(content) {
            switch (content) {
                case 'chat':
                    const cookieChime = that.readCookie('chime');
                    if (cookieChime !== undefined) {
                        loadChimeDependencies(function () {
                            networkHelper.postJSON(_core.getEmbedApiBase() + '/chime-meeting-data', {
                                chatId: that.readCookie('chat-id')
                            }).then((data) => {
                                switch (cookieChime) {
                                    case 'full':
                                        rp.Chime.initVideoChat(data.meeting, data.attendee);
                                        break;
                                    case 'audio':
                                        _chatWrapper.find('section#chat').addClass('chat2voice');
                                        rp.Chime.initAudioChat(data.meeting, data.attendee, _socket);
                                        break;
                                    case 'screenshare':
                                        rp.Chime.initScreenshareChat(data.meeting, data.attendee);
                                        break;
                                    case 'audio-screenshare':
                                        _chatWrapper.find('section#chat').addClass('chat2voice');
                                        rp.Chime.initAudioChat(data.meeting, data.attendee, _clientChat);
                                        rp.Chime.initScreenshareChat(data.meeting, data.attendee);
                                        break;
                                    default:
                                        console.log('Unsupported chime state', cookieChime);
                                }
                            });
                        });
                    }
                    break;
            }
        };

        let _chimeDependenciesLoaded = false;
        function loadChimeDependencies(callback) {
            if (_chimeDependenciesLoaded) {
                callback();
                return;
            }

            networkHelper.loadScript(versionizeUrl(_dialogUrl + '/../assets/js/chime-client.js')).then(() => {
                networkHelper.loadScript(versionizeUrl(_dialogUrl + '/chat-window/common/chime/chime.js')).then(() => {
                    _chimeDependenciesLoaded = true;
                    callback();
                });
            });
        }

        function leaveChimeMeeting() {
            const chimeState = that.readCookie('chime')
            if (chimeState === 'full') {
                if (rp.Chime) {
                    rp.Chime.destroyVideoChat();
                }
            }

            if (!!chimeState && chimeState.includes('screenshare')) {
                if (rp.Chime) {
                    rp.Chime.destroyScreenshareChat();
                }
            }

            if (!!chimeState && chimeState.includes('audio')) {
                if (rp.Chime) {
                    rp.Chime.destroyAudioChat();
                }
            }
        }

        function generateUniqueId() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        }

        this.bindScrollEvents = function ()
        {
            domHelper('#chat-conversation').on('scroll', (e) => {
                const scrollBottom = e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop;
                that.showScrollDownButton(scrollBottom > _chatLineHeight);
            });

            domHelper(document).on('rp-chat-scroll-down', () => {
                that.resetScrollDownLastMessageCount();
                that.scrollToLastMessage(true);
            });
        };

        /**
         * extern (loadchatmodule.js)
         */
        this.bindEvents = function () {
            domHelper(document).on('rp-start-chat', () => {
                that.fillInputFields();
                that.showContent(that.readCookie('isRouting') ? 'routing' : that.readCookie('window'));
            });

            domHelper(document).on('rp-chat-maximize rp-chat-minimize', () => {
                that.toggleLayer();
            });

            domHelper(document).on('rp-chat-restore', () => {
                if (that.readCookie('minimized')) {
                    that.toggleLayer();
                }
            });

            domHelper(document).on('rp-chat-close', () => {
                if (that.readCookie('window') === 'hotline' && !that.readCookie('skip-postchat')) {
                    that.showContent('postchat', true);
                    return;
                }
                if (that.readCookie('window') !== 'chat' || _agentLeft) {
                    that.closeChat();
                    return;
                }
                that.updateCookie('prev-window', that.readCookie('window'));
                that.showContent('close', true);
            });

            domHelper(document).on('rp-exit-skip-postchat', () => {
                that.updateCookie('skip-postchat', true)
                that.closeChat();
            });

            domHelper(document).on('rp-exit-chat', (e) => {
                that.closeChat((e.detail === 'terminate-contact') ? 'contact' : 'postchat');
            });

            domHelper(document).on('rp-info-close rp-back-to-chat', () => {
                that.showContent(that.readCookie('prev-window') || that.readCookie('window'), true);
                that.updateCookie('prev-window', null);
            });

            domHelper(document).on('rp-info-help', () => {
                that.showContent('help');
            });

            domHelper(document).on('rp-info-datasecurity', () => {
                const $el = domHelper('section#datasecurity input#save-transcript-switcher');
                if (typeof that.readCookie('saveTranscript') === "object" || that.readCookie('saveTranscript') == 1) {
                    $el.prop('checked', 'checked');
                } else {
                    $el.prop('checked', false);
                }

                that.showContent('datasecurity');
            });

            domHelper(document).on('rp-info-datasecurity-link', (e) => {
                if (e.target.getAttribute('href') !== '#') {
                    window.open(e.target.getAttribute('href'), 'datasecurity');
                } else {
                    triggerEvent(document, 'rp-info-datasecurity');
                }
                if (rp.chat.TrackModule !== undefined && rp.chat.TrackModule.customerClickLink !== undefined) {
                    rp.chat.TrackModule.customerClickLink('textlink');
                }
            });

            domHelper(document).on('rp-info-liability', () => {
                that.showContent('liability');
            });

            domHelper(document).on('rp-copyright', () => {
            });

            domHelper(document).on('rp-file-upload', () => {
            });

            domHelper(document).on('rp-prechat-submit', that.startRouting);

            domHelper(document).on('rp-email-submit', () => {
                let hasError = false;

                domHelper('form#' + _emailFormId + ' [data-chat-validation]').each((el) => {
                    const $this = domHelper(el);
                    if ($this.attr('required') === undefined && $this.val() === '') {
                        return true;
                    }
                    const regEx = new RegExp($this.data('chat-validation'));
                    const formGroup = $this.closest('.form-group');
                    formGroup.removeClass('has-error');

                    const valid = regEx.test(String(el.value).trim());

                    $this.attr('aria-invalid', !valid);
                    if (!valid) {
                        formGroup.addClass('has-error');
                        hasError = true;
                    }
                });

                domHelper('form#' + _emailFormId + ' [name=data-protection]').each((el) => {
                    const $this = domHelper(el);
                    const formGroup = $this.closest('.form-group');
                    formGroup.removeClass('has-error');

                    if (!el.checked) {
                        formGroup.addClass('has-error');
                        hasError = true;
                    }
                });

                if (hasError) {
                    return;
                }

                const data = Object.assign(
                    {
                        is_mobile: !!_config.isMobile
                    },
                    that.objectifyForm(domHelper('form#' + _emailFormId)[0])
                );

                networkHelper.postFormWithoutReturn(_core.getEmbedApiBase() + '/offline-message/' + _deptId, data).then(() => {
                    var formMailHeader = document.querySelector('#' + _chatWrapperId + ' section#contact .header-contact');
                    var formMail = document.querySelector('#' + _chatWrapperId + ' section#contact #form-email');
                    var formSubmitSuccess = document.querySelector('#' + _chatWrapperId + ' section#contact #submit-success');

                    if (formMailHeader !== null && formMail !== null && formSubmitSuccess !== null) {
                        formMailHeader.classList.add("hidden");
                        formMail.classList.add("hidden");
                        formSubmitSuccess.classList.remove("hidden");
                    } else {
                        that.closeChat();
                    }
                }).catch(() => {
                    that.closeChat();
                    that.logError("sending email failed");
                });
            });


            domHelper(document).on('rp-routing-cancel', () => {
                const chatId = that.readCookie('chat-id');

                networkHelper.getJSON(_core.getEmbedApiBase() + '/cancel-chat/' + _deptId + '/' + chatId, {}).finally(() => {
                    that.killRequestStateWorker();
                    that.cancelChatRouting();
                });
            });

            let lastTypingSent = 0;
            domHelper(document).on('rp-chat-typing', (e) => {
                e = e.detail;
                const pressShift = e.shiftKey;
                const key = (!e.which) ? e.keyCode : e.which;

                if ((!pressShift || _config.isMobile) && key === 13) {
                    e.preventDefault();

                    domHelper('#' +_chatFormId).trigger('submitForm');
                    _clientChat.sendMessage({type:"preview"});
                    _socket.emit('preview', '');
                }

                if (lastTypingSent > Date.now() - 3000) {
                    return;
                }
                lastTypingSent = Date.now();

                _clientChat.sendMessage({type:"customer-typing"});
                _socket.emit('typing');
                const messageElement = domHelper('#' +_chatFormId).find('#message')[0];
                const message = messageElement ? messageElement.value : '';
                _clientChat.sendMessage({type:"preview", payload: {text:message}});
                _socket.emit('preview', that.messageParser(message));
            });

            domHelper(document).on('rp-chat-send', () => {
                if (_chatEnd) {
                    that.processSystemInfo({
                        text: window.rp.layer2_lang.MESSAGE_WAS_NOT_DELIVERED
                    });
                    return;
                }
                const chatForm = domHelper('#' + _chatFormId);
                const messageElement = chatForm.find('#message');
                const message = messageElement.val();

                const data = {
                    name: _customerName ?? window.rp.layer2_lang.CUSTOMER,
                    timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset(),
                    text: that.messageParser(message),
                    dept_id: _deptId,
                    message_id: generateUniqueId()
                };

                chatForm.trigger('reset');
                messageElement.trigger('focus');

                if (!data.text) {
                    return;
                }

                if (!that.getSocketIsConnected() || !that.getMQTTIsConnected()) {
                    that.processSystemInfo({
                        text: window.rp.layer2_lang.MESSAGE_WAS_NOT_DELIVERED
                    });
                    that.scrollToLastMessage();
                    if (typeof _usedQuickReplyAction === 'undefined') {
                        _chatWrapper.find("[name=message]").val(data.text);
                    }
                    _usedQuickReplyAction = undefined;
                    return;
                }

                that.destroyQuickReplies();
                _chatWrapper.find('.js-bot-footnote').addClass('hide');
                _chatWrapper.find('#inputarea').removeClass('botShowInput');
                that.updateCookie('botShowInput', null);

                if (typeof _usedQuickReplyAction === 'object') {
                    data.quickReply = Object.assign({}, _usedQuickReplyAction);
                    _usedQuickReplyAction = undefined;
                }
				_clientChat.sendMessage({type:"customer-message", payload: data});
				_clientChat.sendMessage({type:"preview"});
                _socket.emit('customer-message', data);
                _socket.emit('preview', '');

                const chatId = that.readCookie('chat-id');
                data.chat_id = chatId;

                networkHelper.postJSON(_core.getEmbedApiBase() + '/send-message/' + chatId, data).then((data) => {
					that.processOutgoingMessage(data);
                    if (data['session-ended'] !== undefined) {
                        messageElement.prop('disabled', true);
                        return;
                    }
                    that.scrollToLastMessage();
                });
            });

            domHelper(document).on('rp-pdf-export', () => {
                window.open(_core.getEmbedApiBase() + '/load-pdf-transcript/' + that.readCookie('chat-id') + '/?chat_id=' + that.readCookie('chat-id') + '&token=' + encodeURIComponent(rp.chat.Core.token) + '&dept_id=' + _deptId);
            });

            domHelper(document).on('rp-postchat-submit', (e) => {
                const eventPayload = e.detail || e.originalEvent.detail || {};
                const targetWindow = eventPayload.targetWindow;
                const postchatForm = domHelper('#' + _postchatFormId);
                if (_isPostChatSubmitted) {
                    return;
                }
                const chatId = that.readCookie('chat-id');

                const data = Object.assign(
                    {
                        chat_id: chatId,
                        admin_id: _agentIdentity.id,
                    },
                    that.objectifyForm(postchatForm[0])
                );

                _isPostChatSubmitted = true;

                networkHelper.postFormWithoutReturn(_core.getEmbedApiBase() + '/save-rating', data).then(() => {
                    if (targetWindow) {
						that.showContent(targetWindow, true);
						return;
					}that.closeChat();
                });

            });

            domHelper(document).on('rp-unread-messages', (e) => {
                const payload = e.detail;
                const header = _chatWrapper.find('.chat-header .chat-title');
                if (header.length) {
                    if (!payload || !payload.count) {
                        header.removeAttr('data-unread-count');
                        return;
                    }
                    header.attr('data-unread-count', payload.count);
                }
            });

            domHelper(document).on('rp-unread-messages-scroll-down', () => {
                const unread = that.readCookie('unread');
                const $scrollDownButton = domHelper('.scroll-down-button');
                if ($scrollDownButton.isVisible()) {
                    if (!unread || unread == 0) {
                        $scrollDownButton.removeClass('new_message_count');
                        return;
                    }
                    $scrollDownButton.attr('data-unread-count', unread);
                    $scrollDownButton.addClass('new_message_count');
                }
            });

            _body.on('click', '.js-end-chat', () => {
                that.closeChat();
            });

            domHelper(document).on('rp-quick-reply', (e) => {
                if (that.readCookie('agentLeft') === 0) {
                    const targetElement = e.detail.target;
                    const $target = (targetElement.tagName === 'BUTTON' || targetElement.tagName === 'DIV') ? domHelper(targetElement) : domHelper(targetElement).closest('button');
                    const text = $target.text();
                    _usedQuickReplyAction = $target.data();
                    domHelper('#' + _chatFormId).find('#message').val(text);
                    domHelper('#' + _chatFormId).trigger('submitForm');
                } else {
                    domHelper('[data-chat-event="rp-quick-reply"]').addClass('disabled');
                }
            });

            domHelper(document).on('rp-search-reply-cancel', () => {
                _chatWrapper.find('#search-reply-input').val('');
                const data = {
                    name: _customerName,
                    timestamp: Math.floor(new Date / 1000),
                    text: 'search-reply-fail|search_reply_response',
                    isBot: true,
                    session_rp: _visitorId,
                    isSearchReply: true,
                };
                networkHelper.postJSON(_core.getEmbedApiBase() + '/send-message/' + that.readCookie('chat-id'), data).then(function () {
                    that.scrollToLastMessage();
                    _chatWrapper.find('#search-rerply-input').val('');
                    _chatWrapper.find('.chat-header .chat-title').text('');
                    that.showContent('chat', true);
                });
            });

            domHelper(document).on('rp-search-reply-input', (e) => {
                e.preventDefault();
                e = e.detail;
                if (e.key === "Enter") return false;
                const search = e.target.value.trim();
                if (!search) {
                    if (that.botSearchReply?.searchList?.length) {
                        that.processSearchReply({searchList: that.botSearchReply.searchList});
                    }
                    return false;
                }
                networkHelper.getJSON(_core.getEmbedApiBase() + '/bot-get-search-reply/' + that.readCookie('chat-id') + '/' + search).then((data) => {
                    that.processSearchReply({searchList: data});
                });
                return false;
            });

            _body.on('click', '.js-accept-datasecurity', (e) => {
                const $target = domHelper(e.target);
                const responseText = $target.data('response') || 1;

                $target.closest('div').find('.btn').prop('disabled', true);

                domHelper('#' + _chatFormId).find('#message').val($target.text());
                triggerEvent(document, 'rp-chat-send');

                $target.closest('div').fadeOut('fast');

                const data = {
                    chat_id: that.readCookie('chat-id'),
                    datasecurity: 1,
                    profile_id: _agentIdentity.id,
                    request_id: _requestId,
                    response_text: responseText
                };

                setTimeout(() => {
                    networkHelper.postJSON(_core.getEmbedApiBase() + '/save-datasecurity/' + _deptId, data).then(() => {
                        that.processIncomingMessage({
                            name: '',
                            timestamp: Math.floor(new Date / 1000),
                            text: responseText
                        });
                    });
                }, 1500);

                setTimeout(() => {
                    _clientChat.sendMessage({type:"datasecurity-customer-reaction", payload: {chatId:that.readCookie('chat-id'), reaction:'accept', text:responseText}});
					_socket.emit('datasecurity-customer-reaction', that.readCookie('chat-id'), 'accept', responseText);
                }, 2500);

                if (rp.chat.TrackModule !== undefined && rp.chat.TrackModule.customerAcceptPrivacy !== undefined) {
                    rp.chat.TrackModule.customerAcceptPrivacy();
                }

                that.updateCookie('datasecurity', 'accept');
                that.updateCookie('botDataPrivacy', null);
            });

            _body.on('click', '.js-deny-datasecurity', (e) => {
                const $target = domHelper(e.target);
                const responseText = $target.data('response') || 0;

                $target.closest('div').find('.btn').prop('disabled', true);

                domHelper('#' + _chatFormId).find('#message').val($target.text());
                triggerEvent(document, 'rp-chat-send');

                $target.closest('div').fadeOut('fast');

                const data = {
                    chat_id: that.readCookie('chat-id'),
                    datasecurity: 0,
					profile_id: _agentIdentity.id,
                    request_id: _requestId,
                    response_text: responseText
                };

                setTimeout(() => {
                    networkHelper.postJSON(_core.getEmbedApiBase() + '/save-datasecurity/' + _deptId, data).then(() => {
                        that.processIncomingMessage({
                            name: '',
                            timestamp: Math.floor(new Date / 1000),
                            text: responseText
                        });
                    });
                }, 100);

                setTimeout(() => {
                    _clientChat.sendMessage({type:"datasecurity-customer-reaction", payload: {chatId:that.readCookie('chat-id'), reaction:'deny', text:responseText}});_socket.emit('datasecurity-customer-reaction', that.readCookie('chat-id'), 'deny', responseText);
                }, 2500);

                that.updateCookie('datasecurity', 'deny');
                that.updateCookie('botDataPrivacy', null);
            });

            _body.on('click', '.js-accept-language', (e) => {
                that.updateCookie('useTranslation', 1);
                const $target = domHelper(e.target);
                const responseText = $target.data('response') || $target.text();

                $target.closest('div').find('.btn').prop('disabled', true);

                domHelper('#' + _chatFormId).find('#message').val($target.text());
                triggerEvent(document, 'rp-chat-send');

                $target.closest('div').fadeOut('fast');

                setTimeout(() => {
                    _clientChat.sendMessage({type:"language-customer-reaction", payload: {chatId:that.readCookie('chat-id'), language: $target.text(), languageIso: responseText}});
                    _socket.emit('language-customer-reaction', that.readCookie('chat-id'), responseText);
                }, 2500);

                that.reloadLanguages(responseText);
            });

            domHelper(document).on('rp-bot-show-input-once', () => {
                _chatWrapper.find('#inputarea').addClass('botShowInput');
                that.updateCookie('botShowInput', true);
            });

            domHelper(document).on('rp-bot-show-footnote-once', (e) => {
                _chatWrapper.find('.js-bot-footnote').text(e.detail).removeClass('hide');
            });

            domHelper(document).on('rp-bot-show-data-privacy', (e) => {
                const $outgoingMessage = domHelper('section#templates #template-show-data-privacy > *').clone();

                if (e.detail.question !== undefined && e.detail.question !== '') {
                    $outgoingMessage.find('.question').html(e.detail.question);
                }

                if (e.detail.accept !== undefined && e.detail.reject !== undefined) {
                    $outgoingMessage.find('.accept').text(e.detail.accept);
                    $outgoingMessage.find('.reject').text(e.detail.reject);
                }

                $outgoingMessage.appendTo('#chat-conversation');
            });

            domHelper(document).on('rp-bot-show-rating', (e) => {
                const chatId = that.readCookie('chat-id');
                const url = _dialogUrl + '/layer-v2/show-rating/' + _deptId + '/' + chatId;
                const postData = {};
                const postChatForm = _chatWrapper.find('#' + _postchatFormId);

                if (e.detail) {
                    postData.question_id = e.detail;
                }

                networkHelper.postJSON(url, postData).then((data) => {
                    that.processSystemInfo({
                        text: data
                    }, ($el) => {
                        const questions = [];
                        $el.addClass('chat-bot-survey');

                        $el.find('[data-question-id]').each((el) => {
                            let questionId = el.dataset.questionId;
                            questions.push(questionId);
                            postChatForm.find('[data-question-id=' + questionId + ']').remove();
                        });
                        that.updateCookie('show-rating-active', questions);

                        if (!postChatForm.find('[data-question-id]').length) {
                            that.updateCookie('skip-postchat', true);
                        }

                        that.scrollToLastMessage();
                    });
                });
            });

            domHelper(document).on('rp-submit-bot-survey', (e) => {
                const $button = domHelper(e.target);
                const $form = $button.closest('form');
                const chatId = that.readCookie('chat-id');

                const data = Object.assign({
                    chat_id: chatId,
                    admin_id: _agentIdentity.id,
                    save_to_transcript: true,
                }, that.objectifyForm($form[0]));

                networkHelper.postFormWithoutReturn(_core.getEmbedApiBase() + '/save-rating', data).then(() => {
                    that.updateCookie('show-rating-active', null);
                    const checkMark = document.createElement('i');
                    checkMark.classList.add('fa', 'fa-check');
                    $button.append(checkMark).prop('disabled', true);
                    $form.find('.form-control').each((el) => {
                        domHelper(el).prop('disabled', true);
                    });

                    that.botSendInternalMessage('client_rates_chat', () => {
                        that.scrollToLastMessage();
                    });
                });
            });

            domHelper('#chat-conversation').on('scroll', (e) => {
                const scrollBottom = e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop;
                that.showScrollDownButton(scrollBottom > 30);
            });

            domHelper(document).on('rp-chat-scroll-down', () => {
                that.scrollToLastMessage(true);
            });

            domHelper(document).on('rp-layer-opened', () => {
                domHelper("span#optiRealPersonContent").addClass('rp-hide');
                if (that.readCookie('isRouting')) {
                    that.showContent('routing');
                } else {
                    that.fillInputFields();
                // reset potential queued messages already loaded upon re-init
					_operatorMessageTimeouts.forEach(timeout => clearTimeout(timeout));
					_operatorMessageTimeouts = [];
					that.showTypingMessage(false);

				}
            });

            domHelper(document).on('rp-layer-closed', () => {
                rp.chat.Storage.destroy();
                domHelper("span#optiRealPersonContent").removeClass('rp-hide');
                if (rp.chat.Cobrowsing2) {
                    rp.chat.Cobrowsing2.close();
                }
                if (_socket !== undefined) {
					_socket.emit('customer-close-chat');
				}

                _isPostChatSubmitted = false;
            });

            domHelper(document).on('rp-layer-created', () => {
                if (that.readCookie('closed') != true ) {
                    domHelper("span#optiRealPersonContent").addClass('rp-hide');
                }
            });

            domHelper(document).on('rp-start-chat', () => {
                _statusButtonUsed = true;
                _agentLeft = undefined;
                _chatEnd = undefined;
                if (that.readCookie('minimized')) {
                    that.maximizeLayer();
                }
            });

            _body.on('click', '.cobrowsing-user .cobrowsing-start', function (e) {
                e.preventDefault();

                domHelper(".cobrowsing-user").html("<p id=\"cobrowsing-wait\">" + window.rp.layer2_lang.COBROWSING_ACCEPT_WAIT + "</p>");

                if (rp.chat.Cobrowsing2 === undefined && document.getElementById('realperson-cobrowsingmodul2') === null) {
                    networkHelper.loadScript(versionizeUrl(_collectUrl + "/../js/cobrowsing/cobrowsing-v2-client.js"), "realperson-cobrowsingmodul2")
                        .then(() => {
                            rp.chat.Cobrowsing2 = new rp.chat.CobrowsingModul2();
                            rp.chat.Cobrowsing2.initialize();
                        });
                } else if (rp.chat.Cobrowsing2 === undefined && document.getElementById('realperson-cobrowsingmodul2') !== null) {
                    rp.chat.Cobrowsing2 = new rp.chat.CobrowsingModul2();
                    rp.chat.Cobrowsing2.initialize();
                } else {
                    rp.chat.Cobrowsing2.initialize();
                }

                let data = {
                    timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset(),
                    dept_id: _deptId
                };
				_clientChat.sendMessage({type:"cobrowsing-customer-accept", payload: data});
				_socket.emit('cobrowsing-customer-accept', data);

                data = {
                    chat_id: rp.chat.LayerChat.readCookie('chat-id'),
                    dept_id: _deptId,
                    request_id: _requestId
                };

                networkHelper.postJSON(_core.getEmbedApiBase() + '/accept-cobrowsing/' + _deptId, data);
            });

            _body.on('click', '#screenshare-user .screenshare-start', function (e) {
                e.preventDefault();

                let chatId = that.readCookie('chat-id');
                const dataElement = domHelper(e.target).closest('div#screenshare-user').first();
                if (dataElement.data('screen-id') !== undefined){
                    chatId = dataElement.data('screen-id');
                }

                window.open(_collectUrl + '/screenshare/#' + parseInt(chatId).toString(36) + ',' + _deptId + ',' + _visitorId );
            });

            _body.on('click', '#cobrowsing-close', function (e) {
                e.preventDefault();
                rp.chat.Cobrowsing2.close();

                that.processSystemNotice({ text: window.rp.layer2_lang.COBROWSING_CLOSE_BY_CUSTOMER, timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset() });

                networkHelper.postJSON(_core.getEmbedApiBase() + '/send-message/' + that.readCookie('chat-id'), {
                    timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset(),
                    text: window.rp.layer2_lang.COBROWSING_CLOSE_BY_CUSTOMER,
                    dept_id: _deptId,
                    type: 'alert',
                    chat_id: that.readCookie('chat-id')
                });
            });

            _body.on('click', '#' + _chatWrapperId + ' a[target=_blank]', function(e) {
                const currentHost = window.location.hostname;
                const urlHost = (href) => {
                    const location = document.createElement('a');
                    location.href = href;
                    return location.hostname;
                };
                if ((_config.isMobile) && (currentHost === urlHost(e.target.href))) {
                    e.target.target = '';
                    that.toggleLayer();
                }
            });

            domHelper(document).on('change', 'section#datasecurity input#save-transcript-switcher, section#prechat input#save-transcript', function(e) {
                let saveTranscript = 0;
                if (this.checked) {
                    saveTranscript = 1;
                    domHelper('section#datasecurity input#save-transcript-switcher').prop('checked', 'checked');
                    domHelper('section#prechat input#save-transcript')
                        .prop('checked', 'checked')
                        .val(1);
                } else {
                    domHelper('section#datasecurity input#save-transcript-switcher').prop('checked', false);
                    domHelper('section#prechat input#save-transcript')
                        .prop('checked', false)
                        .val(0);
                }
                that.updateCookie('saveTranscript', saveTranscript);
                setSaveTranscript(saveTranscript);
            });

            document.addEventListener('scroll', (e) => {
                if (!e.target.classList || !e.target.classList.contains('rp-template-generic')) {
                    return;
                }

                const $container = domHelper(e.target);
                const leftVisibility = e.target.scrollLeft > 0 ? 'visible' : 'hidden';
                $container.find('.rp-template-prev').each(el => {
                    el.style.visibility = leftVisibility;
                    el.style.opacity = leftVisibility === 'hidden' ? 0 : 1;
                });

                const rightVisibility = e.target.scrollLeft < e.target.scrollWidth - e.target.clientWidth ? 'visible' : 'hidden';
                $container.find('.rp-template-next').each(el => {
                    el.style.visibility = rightVisibility;
                    el.style.opacity = rightVisibility === 'hidden' ? 0 : 1;
                });
            }, true);

            _body.on('click', '.rp-template-prev, .rp-template-next', function (e) {
                const $container = domHelper(e.target).closest('.rp-template-generic');
                const direction = $container.hasClass('rp-template-prev') ? 'prev' : 'next';
                const oldScrollLeft = $container[0].scrollLeft;
                let index = 0;
                $container.find('.rp-template-element').each((el, i) => {
                    if (direction === 'prev' && el.offsetLeft < oldScrollLeft) {
                        index = i;
                    }
                    if (direction === 'next' && el.offsetLeft > oldScrollLeft) {
                        index = index || i + 1; // only use first
                    }
                });
                const $firstElement = $container.find('.rp-template-element').first();
                const firstElementWidth = $firstElement.getBoundingClientRect().width;
                const containerWidth = $container.getBoundingClientRect().width;
                const newScrollLeft = index * firstElementWidth - (containerWidth - firstElementWidth) / 2;
                $container[0].scrollTo({ left: newScrollLeft, behavior: 'smooth' });
            });

            domHelper(document).on('rp-template-button', (e) => {
                const $target = domHelper(e.target);

                // only handle if template is last message
                const $closestMessage = $target.closest('.message');
                if ($closestMessage[0] !== domHelper('#chat-conversation > .message').last()[0]) {
                    return;
                }

                domHelper('#' + _chatFormId).find('#message').val($target.attr('data-payload'));
                domHelper('#' + _chatFormId).trigger('submitForm');

            });

            // Screenshare - accept invite
			domHelper(document).on('rp-screenshare-start', function (e) {
                that.addFeatureToChimeCookie('screenshare');
				domHelper(e.target).prop('disabled', true);
				domHelper(".screenshare-invite").html("<p id=\"screenshare-wait\">" + window.rp.layer2_lang.SCREENSHARE_ACCEPT_WAIT + "</p>");
				_chatWrapper.find('section#chat #chat-conversation #screenshare-reconnect-message').closest('.message').remove();
				_chatWrapper.find('section#chat').addClass('chat2video');

				loadChimeDependencies(function () {
					networkHelper.postJSON(_core.getEmbedApiBase() + '/chime-meeting-data', {
						chatId: that.readCookie('chat-id')
					}).then(function (data) {
						rp.Chime.initScreenshareChat(data.meeting, data.attendee);
						data = {
							chat_id: that.readCookie('chat-id'),
							dept_id: _deptId,
							request_id: _requestId,
						};
						networkHelper.postJSON(_core.getEmbedApiBase() + '/accept-screenshare/' + _deptId, data);
						that.sendToSocket('screenshare-customer-accept', that.uuidv4());
						that.resizeChat();
					});
				});
			});

			// Chat2Video - accept invite
            domHelper(document).on('rp-chat2video-start', function (e) {
                that.updateCookie('chime', 'full');
                domHelper(e.target).prop('disabled', true);
                _chatWrapper.find('section#chat #chat-conversation #chat2video-reconnect-message').closest('.message').remove();
                _chatWrapper.find('section#chat').addClass('chat2video');

                loadChimeDependencies(function () {
                    networkHelper.postJSON(_core.getEmbedApiBase() + '/chime-meeting-data', {
                        chatId: that.readCookie('chat-id')
                    }).then((data) => {
                        rp.Chime.initVideoChat(data.meeting, data.attendee);
                    });
                });

                const targetDepartmentId = domHelper(e.target).data('target-department');
                const targetProfileId = domHelper(e.target).data('target-profile');
                const profileId = domHelper(e.target).data('profile');
                data = {
                    chat_id: rp.chat.LayerChat.readCookie('chat-id'),
                    dept_id: _deptId,
                    request_id: _requestId,
                    profile_id: profileId,
                    target_department_id: targetDepartmentId,
                    target_profile_id: targetProfileId
                };
                networkHelper.postJSON(_core.getEmbedApiBase() + '/accept-chat2video/' + _deptId, data).then(_ => {});
                that.sendToSocket('chat2video-customer-accept', that.uuidv4());
            });

            // Chat2Voice - accept invite
            domHelper(document).on('rp-chat2voice-start', (e) => {
                that.addFeatureToChimeCookie('audio');
                domHelper(e.target).prop('disabled', true);
                domHelper(".voice-invite").html("<p id=\"screenshare-wait\">" + window.rp.layer2_lang.VOICE_ACCEPT_WAIT + "</p>");
                _chatWrapper.find('section#chat #chat-conversation #chat2voice-reconnect-message').closest('.message').remove();
                _chatWrapper.find('section#chat').addClass('chat2voice');

                loadChimeDependencies(function () {
                    networkHelper.postJSON(_core.getEmbedApiBase() + '/chime-meeting-data', {
                        chatId: that.readCookie('chat-id')
                    }).then((data) => {
                        rp.Chime.initAudioChat(data.meeting, data.attendee, _clientChat);
						data = {
							chat_id: that.readCookie('chat-id'),
							dept_id: _deptId,
							request_id: _requestId,
						};
						networkHelper.postJSON(_core.getEmbedApiBase() + '/accept-voice/' + _deptId, data);
                        that.sendToSocket('chat2voice-customer-accept', that.uuidv4());
                    });
                });
            });

            domHelper(document).on('rp-chat2voice-hangup', () => {
                if (!that.hasActiveChimeCookie('audio')) {
                    return;
                }
                window.stopAudioChat(true);
                _clientChat.sendMessage({type: 'chat2voice-hangup'});_chatWrapper.find('section#chat').removeClass('chat2voice');
                that.removeFromChimeCookie('audio');
            that.processSystemNotice({text: window.rp.layer2_lang.VOICE_ENDED, timestamp: new Date().getTime()});
			});

            domHelper(document).on('rp-chat-ended', () => {
                triggerEvent(document, 'rp-chat2voice-hangup');
            });

            domHelper(document).on('rp-chat2screenshare-hangup', () => {
				if  (!that.hasActiveChimeCookie('screenshare')) {
					return;
				}
				window.stopScreenshareChat();
				that.removeFromChimeCookie('screenshare');
			});

            domHelper(document).on('rp-chat2voice-cancel', () => {
                _chatWrapper.find('section#chat #chat-conversation #chat2voice-reconnect-message').closest('.message').remove();
                that.removeFromChimeCookie('audio');
            });

            domHelper(document).on('rp-agent-identity', (e) => {
                const payload = e.detail;
                const $header = _chatWrapper.find('.chat-header .chat-title');

                $header.addClass('agent-connected');

                if (payload.picture !== undefined) {
                    $header.addClass('agent-has-picture');
                }
            });

            domHelper(document).on('rp-info-cookie-accepted', () => {
                networkHelper.postJSON(_core.getEmbedApiBase() + '/cookie-accept');
                rp.chat.Core.startChat();
            });
        };

        this.fillInputFields = function () {
            if (that.readCookie('window') === 'prechat') {
                const $prechatForm = _chatWrapper.find("#" + _prechatFormId);
                if (rp.chat.Storage.has("prechat", "name")) $prechatForm.find("[name=name]").val(rp.chat.Storage.get("prechat", "name"));
                if (rp.chat.Storage.has("prechat", "email")) $prechatForm.find("[name=email]").val(rp.chat.Storage.get("prechat", "email"));
                if (rp.chat.Storage.has("prechat", "message")) $prechatForm.find("[name=message]").val(rp.chat.Storage.get("prechat", "message"));
                if (rp.chat.Storage.has("prechat", "save_transcript")) $prechatForm.find("[name=save_transcript]").val([rp.chat.Storage.get("prechat", "save_transcript")]);
            } else if (that.readCookie('window') === 'chat') {
                const $chatForm = _chatWrapper.find("#" + _chatFormId);
                if (rp.chat.Storage.has("chat", "message")) $chatForm.find("[name=message]").val(rp.chat.Storage.get("chat", "message"));
            } else if (that.readCookie('window') === 'contact') {
                const $emailForm = _chatWrapper.find("#" + _emailFormId);
                if (rp.chat.Storage.has("prechat", "name")) $emailForm.find("[name=name]").val(rp.chat.Storage.get("prechat", "name"));
                if (rp.chat.Storage.has("prechat", "email")) $emailForm.find("[name=email]").val(rp.chat.Storage.get("prechat", "email"));
                if (rp.chat.Storage.has("prechat", "message")) $emailForm.find("[name=message]").val(rp.chat.Storage.get("prechat", "message"));
            }
        };

        this.logError = function(message, response) {
            const id = response.id !== undefined ? ", chat event: " + response.id : "";
            console.error(message, id);
        };

        this.cancelChatRouting = function() {
            that.resetForm(_prechatFormId);
            that.updateCookie('datasecurity', undefined);
            that.stopPing();
            that.closeChat();

            if (rp.chat.TrackModule !== undefined && rp.chat.TrackModule.customerCancelRequest !== undefined) {
                rp.chat.TrackModule.customerCancelRequest();
            }
        };

        that.resetForm = function(id) {
            const formSelector = 'form#' + id;
            if (domHelper(formSelector).length) {
                domHelper(formSelector)[0].reset();
            }
        };

        this.messageParser = function(message) {
            return message.replace(/<.*?>/g, '').trim();
        };

        this.bindMQTTEvents = function () {
			_clientChat.on('error', function (err) {
				if (err instanceof Error) {
					console.error('Mqtt error', { message: err.message, data: err.data });
				}
			});

			_clientChat.on('join', function () {
				var chat_id = that.readCookie('chat-id');
				if (chat_id) {
					if (_isReconnecting) {
						_isReconnecting = false;

						networkHelper.getJSON(_core.getEmbedApiBase() + '/ischatting', {_: new Date().getTime()}, function(data) {
							if (chat_id == data.chat_id) {
								domHelper('#chat-conversation').html('');
								that.processTranscriptEvents(data.events);
								if (data.quick_replies && data.quick_replies.length) {
									that.processQuickReplies(data.quick_replies, data.quick_replies_type);
								}
                                if (data.search_replies && data.search_replies.length) {
                                    that.botSearchReply = data.search_replies;
                                    that.processSearchReply(data.search_replies);
                                }
								that.scrollToLastMessage();
								that.resetScrollDownLastMessageCount();

								if (data.identity) {
									triggerEvent(document, 'rp-agent-identity', {
										name: data.identity.name,
										picture: !data.identity.picture ? undefined : data.identity.picture
									});
								}
								if (typeof that.readCookie('datasecurity') !== 'undefined') {
									domHelper('.js-accept-datasecurity').closest('div').addClass('hidden');
								}
							} else {
								console.log('chat_id does not match');
							}
							if (!data.is_chatting) {
								that.stopPing();
                                domHelper('#' + _chatFormId).find('#message').prop('disabled', true);
                                domHelper('#' + _chatFormId).find('#send_button').prop('disabled', true);
                                that.swapMessageBoxForPdfButton();
								that._uploader !== undefined && that._uploader.disable();
								_agentLeft = true;
								if (_agentDisconnectedTimer) {
									clearTimeout(_agentDisconnectedTimer);
									_agentDisconnectedTimer = undefined;
									_operatorMessageTimeouts.forEach(timeout => clearTimeout(timeout));
									_operatorMessageTimeouts = [];
								}
								that.scrollToLastMessage();
								if (rp.chat.Cobrowsing2) rp.chat.Cobrowsing2.close();

								if (typeof rp.chat.TrackModule !== "undefined" && typeof rp.chat.TrackModule.closeChat !== "undefined") {
									rp.chat.TrackModule.closeChat('operator');
								}
							}
						});
					}
				}
			});

			_clientChat.on('message', async function ({data}) {
				const type = data.msg.type;
				const payload = data.msg.payload;
				switch (type) {
					case 'agent-identity':
						domHelper('#' +_chatFormId).find('#send_button').prop('disabled', false);
						if (typeof payload !== "undefined") {
							if (typeof _agentLeft === "undefined") {
								that.processAgentIdentity(payload);
							}
						}

						if (_handoverInitiated === true) {
							_handoverInitiated = false;
							_clientChat.sendMessage({type: 'bot-handover-success'});
							clearTimeout(delayRoutingWindowTimeout);
						} else {
							that.stopPing();
							that.ping({
								chat_id: payload.chat_id,
							});
						}

						that.showContent('chat', true);
						that.killRequestStateWorker();

						if (_agentDisconnectedTimer) {
							clearTimeout(_agentDisconnectedTimer);
							_agentDisconnectedTimer = undefined;
							_operatorMessageTimeouts.forEach(timeout => clearTimeout(timeout));
							_operatorMessageTimeouts = [];
						}

						if (payload.greeting_message && typeof _agentLeft === "undefined") {
							that.processSystemInfo({ text: payload.greeting_message }, function(sysInfoElem) {
								if(payload.transfer) {
									sysInfoElem.addClass('transfer').find('.answer-selection').remove();
								}
							});
						}

						that.scrollToLastMessage();

						if (typeof _agentLeft !== "undefined") {
							that.stopPing();
						}
						break;
					case 'operator-message':
						if (typeof _agentLeft !== "undefined" && typeof _chatEnd !== "undefined") {
							return;
						}

						if (payload.isSystemNotice) {
							return that.processSystemNotice(payload);
						}

						var delay = 0;
						if (payload.delay) {
							delay = payload.delay;
							that.showTypingMessage(true);
							if (delay > 2000) {
								setTimeout(function () {
									that.showTypingMessage(true);
								}, 2000);
							}
						}

						_operatorMessageTimeouts.push(
							setTimeout(function() {
								const handle = () => {
									that.showTypingMessage(false);

									if (payload.quickReplies && payload.quickReplies.length) {
										that.processQuickReplies(payload.quickReplies, payload.quickRepliesType);
									}

									if (payload.actions && payload.actions.length) {
                                        domHelper(payload.actions).each(function (index, action) {
											that.processAction(action);
										});
									}
								};

								if (!payload.text) {
									domHelper('#chat-conversation .typing').remove();
									handle();

									return;
								}

								that.processIncomingMessage(payload, handle);
							}, delay)
						);

						if (!_chatWrapper.find('.chat-body').isVisible()) {
							var unread = that.readCookie('unread') + 1;
							triggerEvent(document, 'rp-unread-messages', {
								count: unread,
								last: payload.text,
								picture: !_agentIdentity.picture ? undefined : _agentIdentity.picture
							});
							that.updateCookie('unread', unread);
						}
						break;
					case 'agent-disconnected':
						if (typeof _agentDisconnectedTimer == 'undefined' && typeof _agentLeft == 'undefined') {
							_agentDisconnectedTimer = setTimeout(function() {
								_clientChat.sendMessage({type: 'timeout-customer'});
								if (rp.chat.Cobrowsing2) rp.chat.Cobrowsing2.close();
							}, _agentDisconnectedTimeout);
						}
						break;
                        case 'timeout-agent':
						that.timeoutAgent();
						break;
					case 'end-inactive-chat':
						if (typeof _agentLeft === "undefined" && typeof _chatEnd === "undefined") {
							that.processSystemNotice({
								text: window.rp.layer2_lang.CHAT_PARTYLEFTSESSION_IDLE,
								timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset()
							});
						}
                        domHelper('#' + _chatFormId).find('#message').prop('disabled', true);
                        domHelper('#' + _chatFormId).find('#send_button').prop('disabled', true);
                        that.swapMessageBoxForPdfButton();
						that._uploader !== undefined && that._uploader.disable();
						that.stopPing();
						leaveChimeMeeting();
						that.scrollToLastMessage();
						_agentLeft = true;
						_chatEnd = true;
						break;
                    case 'agent-left':
						if (typeof _agentLeft === "undefined") {
							var noticeMessage = window.rp.layer2_lang.CHAT_PARTYLEFTSESSION_AGENT;
							noticeMessage = noticeMessage.replace(/%%agent%%/i, _agentIdentity.name);

							that.processSystemNotice({
								text: noticeMessage,
								timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset()
							});
						}
						that.stopPing();
						leaveChimeMeeting();
						domHelper('#' + _chatFormId).find('#message').prop('disabled', true);
						domHelper('#' + _chatFormId).find('#send_button').prop('disabled', true);
                        that.swapMessageBoxForPdfButton();
						that._uploader !== undefined && that._uploader.disable();
						_agentLeft = true;
						that.updateCookie('agentLeft', 1);
						if (_agentDisconnectedTimer) {
							clearTimeout(_agentDisconnectedTimer);
							_agentDisconnectedTimer = undefined;
							_operatorMessageTimeouts.forEach(timeout => clearTimeout(timeout));
							_operatorMessageTimeouts = [];
						}
						that.scrollToLastMessage();
						if (rp.chat.Cobrowsing2) rp.chat.Cobrowsing2.close();

						domHelper('[data-chat-event="rp-quick-reply"]').addClass('disabled');

						triggerEvent(document, 'rp-chat2voice-hangup');
						break;
					case 'connect':

						break;
					case 'joined':
						_clientChat.sendMessage({type: 'preview'});
						break;
					case 'agent-typing':
						if (_typingTimeout) {
							clearTimeout(_typingTimeout);
						}
						that.showTypingMessage(true);
						_typingTimeout = setTimeout(function () {
							_typingTimeout = undefined;
							that.showTypingMessage(false);
						}, 5000);
						break;
					case 'transfer-initiated':
						that.updateCookie('isRouting', true);
						that.showContent('routing');
						that.runRequestStateWorker();
						if(payload.text) {
							that.processSystemNotice({ text: payload.text, timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset() });
							that.scrollToLastMessage();
						}
						break;
					case 'bot-handover-initiated':
						if (_handoverInitiated) {
							break;
						}
						if (payload.status && payload.success) {
							_handoverInitiated = true;
							that.stopPing();

							_handoverOldChat = {
								deptId: _deptId,
								requestId: _requestId,
								chatId: that.readCookie('chat-id'),
								offlineWindow: _config.offlineWindow,
							};

							_deptId = parseInt(payload.deptId);
							that.updateCookie('dept-id', _deptId);
							_requestId = payload.requestId;
							_config.offlineWindow = payload.offlineWindow;
							that.updateCookie('chat-id', payload.chatId);

                            await _clientChat.stopChat();
                            await _clientChat.startChat(payload.chatId);

							that.stopPing()

							payload.oldChatId = _handoverOldChat.chatId;
                            payload.chat_id = payload.chatId;

							networkHelper.postJSON(_core.getEmbedApiBase() + '/bot-handover/' + payload.chatId, payload).then(function (handoverResponse) {

								that.ping({
									chat_id: payload.chatId,
								});

								if (_handoverOldChat.deptId !== _deptId) {
									that.reloadDeptSections(_deptId);
									lastInitDeptId = _deptId;
								}

								if (handoverResponse.queueText && handoverResponse.queueText != '') {
									that.displayQueueText(handoverResponse.queueText);
								}

								_isBot = false;
								that.updateCookie('isRouting', true);
								const delayRoutingWindow = payload.delayRoutingWindow || 0;
								if (document.querySelector('#' + _chatWrapperId + ' #send_button') !== null) {
									document.querySelector('#' + _chatWrapperId + ' #send_button').disabled = true;
								}
								if (document.querySelector('#' + _chatWrapperId + ' #message') !== null) {
									document.querySelector('#' + _chatWrapperId + ' #message').disabled = true;
								}
								clearTimeout(delayRoutingWindowTimeout);
								delayRoutingWindowTimeout = setTimeout(function() {
									that.showContent('routing');
									if (document.querySelector('#' + _chatWrapperId + ' #send_button') !== null) {
										document.querySelector('#' + _chatWrapperId + ' #send_button').disabled = false;
									}
									if (document.querySelector('#' + _chatWrapperId + ' #message') !== null) {
										document.querySelector('#' + _chatWrapperId + ' #message').disabled = false;
									}
								}, delayRoutingWindow * 1000);

								that.runRequestStateWorker(function () {
									that.stopPing();
									that.processBotHandoverFailure(payload);
								});
							});
						}
						break;
					case 'disconnect':
						_isReconnecting = true;
						console.log('verbindung getrennt');
						break;
					case 'bot-handover-failure':
						that.processBotHandoverFailure(payload);
						break;
					case 'chat2voice-hangup':
						triggerEvent(document, 'rp-chat2voice-hangup');
						break;
					case 'delivered-transmission':
						that.successfullyDeliveredDataToSocket(payload.messageId);
						break;
					case 'chat2screenshare-hangup':
						triggerEvent(document, 'rp-chat2screenshare-hangup');
						break;
				}
			})
		};

		this.bindSocketEvents = function () {
            _socket.on('agent-identity', (identity) => {
                domHelper('#' +_chatFormId).find('#send_button').prop('disabled', false);

                if (identity !== undefined) {
                    if (_agentLeft === undefined) {
                        that.processAgentIdentity(identity);
                    }
                }

				if (_handoverInitiated === true) {
					_handoverInitiated = false;
					_socket.emit('bot-handover-success');
					clearTimeout(delayRoutingWindowTimeout);
				} else {
                    that.stopPing();
                    that.ping({
                        chat_id: identity.chat_id,
                    });
                }

                that.showContent('chat', true);
                that.killRequestStateWorker();

                if (_agentDisconnectedTimer) {
                    clearTimeout(_agentDisconnectedTimer);
                    _agentDisconnectedTimer = undefined;
                    _operatorMessageTimeouts.forEach((timeout) => clearTimeout(timeout));
                    _operatorMessageTimeouts = [];
                }

                if (identity.greeting_message && _agentLeft === undefined) {
                    that.processSystemInfo({ text: identity.greeting_message }, ($sysInfoElem) => {
                        if (identity.transfer) {
                            $sysInfoElem.addClass('transfer').find('.answer-selection').remove();
                        }
                    });
                }

                that.scrollToLastMessage();

                if (_agentLeft !== undefined) {
                    that.stopPing();
                }
            });

			_socket.on('customer-close-chat', () => {
                _chatWrapper.fadeOut(_fadeOutTime, () => {
                    that.resetForm(_prechatFormId);
                    domHelper('#chat-conversation').html('');
                    _socket.emit('leave');
                    _clientChat.stopChat();clearTimeout(_agentDisconnectedTimer);
                    _agentDisconnectedTimer = undefined;
                    _operatorMessageTimeouts.forEach((timeout) => clearTimeout(timeout));
                    _operatorMessageTimeouts = [];
                    that.showContent('prechat', true, null, true);

					triggerEvent(document, 'rp-layer-closed');
					that.removeCookie();
				});
			});

            _socket.on('operator-message', (data) => {
                if (_agentLeft !== undefined) {
                    return;
                }

                if (data.isSystemNotice) {
                    return that.processSystemNotice(data);
                }

                let delay = 0;
                if (data.delay) {
                    delay = data.delay;
                    that.showTypingMessage(true);
					if (delay > 2000) {
						setTimeout(() => {
							that.showTypingMessage(true);
						}, 2000);
					}
                }

                _operatorMessageTimeouts.push(
                    setTimeout(() => {
                        const handle = () => {
                            that.showTypingMessage(false);

                            if (data.quickReplies && data.quickReplies.length) {
                                that.processQuickReplies(data.quickReplies, data.quickRepliesType);
                            }

                            if (data.searchReply && data.searchReply.searchList && data.searchReply.searchList.length) {
                                _chatWrapper.find('#search-reply-input').val('');
                                that.botSearchReply = data.searchReply;
                                that.processSearchReply(data.searchReply);
                                that.showContent('search-reply', true);
                            }

                            if (data.actions && data.actions.length) {
                                data.actions.forEach((action) => {
                                    that.processAction(action);
                                });
                            }
                        };

                        if (!data.text) {
                            domHelper('#chat-conversation .typing').remove();
                            handle();

                            return;
                        }

                        that.processIncomingMessage(data, handle);
                    }, delay)
                );

                if (!_chatWrapper.find('.chat-body').isVisible()) {
                    const unread = that.readCookie('unread') + 1;
                    triggerEvent(document, 'rp-unread-messages', {
                        count: unread,
                        last: data.text,
                        picture: !_agentIdentity.picture ? undefined : _agentIdentity.picture
                    });
                    that.updateCookie('unread', unread);
                }
            });

            _socket.on('agent-disconnected', () => {
                if (_agentDisconnectedTimer === undefined && _agentLeft === undefined) {
                    _agentDisconnectedTimer = setTimeout(() => {
						_socket.emit('timeout');
                        if (rp.chat.Cobrowsing2) {
                            rp.chat.Cobrowsing2.close();
                        }
                    }, _agentDisconnectedTimeout);
                }
            });

            _socket.on('timeout-agent', () => {
                if (_agentLeft === undefined) {
                    that.processSystemNotice({
                        text: window.rp.layer2_lang.CHAT_PARTYLEFTSESSION_TIMEOUT,
                        timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset()
                    });
                }
                domHelper('#' + _chatFormId).find('#message').prop('disabled', true);
                domHelper('#' + _chatFormId).find('#send_button').prop('disabled', true);
                that.swapMessageBoxForPdfButton();
                that.stopPing();
                leaveChimeMeeting();
                that.scrollToLastMessage();
                _agentLeft = true;
            });

            _socket.on('end-inactive-chat', () => {
                if (typeof _agentLeft === "undefined" && typeof _chatEnd === "undefined") {
                    that.processSystemNotice({
                        text: window.rp.layer2_lang.CHAT_PARTYLEFTSESSION_IDLE,
                        timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset()
                    });
                }
                domHelper('#' + _chatFormId).find('#message').prop('disabled', true);
                domHelper('#' + _chatFormId).find('#send_button').prop('disabled', true);
                that.swapMessageBoxForPdfButton();
                that.stopPing();
                leaveChimeMeeting();
                that.scrollToLastMessage();
                _agentLeft = true;
            });

            _socket.on('agent-left', () => {
				if (_agentLeft === undefined) {
					let noticeMessage = window.rp.layer2_lang.CHAT_PARTYLEFTSESSION_AGENT;
					noticeMessage = noticeMessage.replace(/%%agent%%/i, _agentIdentity.name);

					that.processSystemNotice({
						text: noticeMessage,
						timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset()
					});
				}
				that.stopPing();
                leaveChimeMeeting();
                domHelper('#' + _chatFormId).find('#message').prop('disabled', true);
                domHelper('#' + _chatFormId).find('#send_button').prop('disabled', true);
                that.swapMessageBoxForPdfButton();
                _agentLeft = true;
				that.updateCookie('agentLeft', 1);
                if (_agentDisconnectedTimer) {
                    clearTimeout(_agentDisconnectedTimer);
                    _agentDisconnectedTimer = undefined;
                    _operatorMessageTimeouts.forEach((timeout) => clearTimeout(timeout));
                    _operatorMessageTimeouts = [];
                }
                that.scrollToLastMessage();
				if (rp.chat.Cobrowsing2) {
                    rp.chat.Cobrowsing2.close();
                }

				domHelper('[data-chat-event="rp-quick-reply"]').addClass('disabled');
            });

            _socket.on('connect_error', (err) => {
                if (err instanceof Error) {
                    console.error('Socket error', { message: err.message, data: err.data });
                }
            });

            _socket.on('connect', () => {
                const chatId = that.readCookie('chat-id');
                if (chatId) {
                    _socket.emit('join', chatId);

                    if (_isReconnecting) {
                        _isReconnecting = false;

                        networkHelper.getJSON(_core.getEmbedApiBase() + '/ischatting').then((data) => {
                            if (chatId == data.chat_id) {
                                domHelper('#chat-conversation').html('');
                                that.processTranscriptEvents(data.events);
                                if (data.quick_replies && data.quick_replies.length) {
                                    that.processQuickReplies(data.quick_replies, data.quick_replies_type);
                                }
                                if (data.search_replies && data.search_replies.length) {
                                    that.botSearchReply = data.search_replies;
                                    that.processSearchReply(data.search_replies);
                                }
                                that.scrollToLastMessage();
                                that.resetScrollDownLastMessageCount();

                                if (data.identity) {
                                    triggerEvent(document, 'rp-agent-identity', {
                                        name: data.identity.name,
                                        picture: !data.identity.picture ? undefined : data.identity.picture
                                    });
                                }
                                if (that.readCookie('datasecurity') !== undefined) {
                                    domHelper('.js-accept-datasecurity').closest('div').addClass('hidden');
                                }
                            } else {
                                console.log('chat_id does not match');
                            }
                            if (!data.is_chatting) {
                                that.stopPing();
                                domHelper('#' + _chatFormId).find('#message').prop('disabled', true);
                                domHelper('#' + _chatFormId).find('#send_button').prop('disabled', true);
                                that.swapMessageBoxForPdfButton();
                                _agentLeft = true;
                                if (_agentDisconnectedTimer) {
                                    clearTimeout(_agentDisconnectedTimer);
                                    _agentDisconnectedTimer = undefined;
                                    _operatorMessageTimeouts.forEach((timeout) => clearTimeout(timeout));
                                    _operatorMessageTimeouts = [];
                                }
                                that.scrollToLastMessage();
                                if (rp.chat.Cobrowsing2) {
                                    rp.chat.Cobrowsing2.close();
                                }

                                if (rp.chat.TrackModule !== undefined && rp.chat.TrackModule.closeChat !== undefined) {
                                    rp.chat.TrackModule.closeChat('operator');
                                }
                            }
                        });
                    }
                }
            });

			_socket.on('joined', () => {
				_socket.emit('preview', '');
            });

            _socket.on('agent-typing', (data) => {
                if (_typingTimeout) {
                    clearTimeout(_typingTimeout);
                }
                that.showTypingMessage(true);
                if (!data.type || data.type !== 'bot') {
                    _typingTimeout = setTimeout(() => {
                        _typingTimeout = undefined;
                        that.showTypingMessage(false);
                    }, 2000);
                }
            });

            _socket.on('transfer-initiated', (text) => {
                that.updateCookie('isRouting', true);
                that.showContent('routing');that.runRequestStateWorker();
                if (text) {
                    that.processSystemNotice({ text: text, timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset() });
                    that.scrollToLastMessage();
                }
            });

            _socket.on('bot-handover-initiated', async (data) => {
                if (!data.status && !data.success) return;
                if (_handoverInitiated) return;

                _handoverInitiated = true;

                that.stopPing();
                _socket.emit('leave', true);

				_handoverOldChat = {
					deptId: _deptId,
					requestId: _requestId,
					chatId: that.readCookie('chat-id'),
					offlineWindow: _config.offlineWindow,
				};

				_deptId = parseInt(data.deptId);
				that.updateCookie('dept-id', _deptId);
				_requestId = data.requestId;
				_config.offlineWindow = data.offlineWindow;
				that.updateCookie('chat-id', data.chatId);
				_socket.emit('join', data.chatId);

				await _clientChat.stopChat();
				await _clientChat.startChat(data.chatId);

				that.stopPing()

				data.oldChatId = _handoverOldChat.chatId;
                data.chat_id = data.chatId;

                networkHelper.postJSON(_core.getEmbedApiBase() + '/bot-handover/' + data.chatId, data).then((handoverResponse) => {
                    that.ping({
                        chat_id: data.chatId,
                    });

                    if (_handoverOldChat.deptId !== _deptId) {
                        that.reloadDeptSections(_deptId);
                        lastInitDeptId = _deptId;
                    }

                    if (handoverResponse.queueText && handoverResponse.queueText != '') {
                        that.displayQueueText(handoverResponse.queueText);
                    }

                    _isBot = false;
                    that.updateCookie('isRouting', true);
                    const delayRoutingWindow = data.delayRoutingWindow || 0;
                    if (document.querySelector('#' + _chatWrapperId + ' #send_button') !== null) {
                        document.querySelector('#' + _chatWrapperId + ' #send_button').disabled = true;
                    }
                    if (document.querySelector('#' + _chatWrapperId + ' #message') !== null) {
                        document.querySelector('#' + _chatWrapperId + ' #message').disabled = true;
                    }
                    clearTimeout(delayRoutingWindowTimeout);
                    delayRoutingWindowTimeout = setTimeout(function () {
                        that.showContent('routing');
                        if (document.querySelector('#' + _chatWrapperId + ' #send_button') !== null) {
                            document.querySelector('#' + _chatWrapperId + ' #send_button').disabled = false;
                        }
                        if (document.querySelector('#' + _chatWrapperId + ' #message') !== null) {
                            document.querySelector('#' + _chatWrapperId + ' #message').disabled = false;
                        }
                    }, delayRoutingWindow * 1000);

                    that.runRequestStateWorker(() => {
                        that.stopPing();
                        that.processBotHandoverFailure(data);
                    });
                });
            });

            _socket.on('agent-left', () => {
                triggerEvent(document, 'rp-chat2voice-hangup');
            });

            _socket.on('disconnect', () => {
                _isReconnecting = true;
                console.log('verbindung getrennt');
            });

            _socket.on('bot-handover-failure', (data) => {
                that.processBotHandoverFailure(data);
            });

            _socket.on('chat2voice-hangup', () => {
                triggerEvent(document, 'rp-chat2voice-hangup');
            });

			_socket.on('delivered-transmission', (messageId) => {
				that.successfullyDeliveredDataToSocket(messageId);
			});
        };

        this.timeoutAgent = function () {
			if (typeof _agentLeft === "undefined") {
				that.processSystemNotice({
					text: window.rp.layer2_lang.CHAT_PARTYLEFTSESSION_TIMEOUT,
					timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset()
				});
			}
            domHelper('#' + _chatFormId).find('#message').prop('disabled', true);
            domHelper('#' + _chatFormId).find('#send_button').prop('disabled', true);
            that.swapMessageBoxForPdfButton();
			that._uploader !== undefined && that._uploader.disable();
			that.stopPing();
			leaveChimeMeeting();
			that.scrollToLastMessage();
			_agentLeft = true;
		};

		this.customerCloseChat = function () {
			_chatWrapper.fadeOut(_fadeOutTime, function() {
				that.resetForm(_prechatFormId);
				domHelper('#chat-conversation').html('');
				if (_clientChat.client != null && _clientChat.client.connected) {
					_clientChat.stopChat();
				}
				clearTimeout(_agentDisconnectedTimer);
				_agentDisconnectedTimer = undefined;
				_operatorMessageTimeouts.forEach(timeout => clearTimeout(timeout));
				_operatorMessageTimeouts = [];
				that.showContent('prechat', true, null, true);

				triggerEvent(document, 'rp-layer-closed');
				that.removeCookie();
			});
		};

		this.processBotHandoverFailure = function (data) {
            clearTimeout(that.delayRoutingWindowTimeout);
            _socket.emit('bot-handover-failure', data);
            switch (data.handover_failure_event) {
                case 'offline_window':
                    _deptId = parseInt(data.deptId);
                    _config.offlineWindow = data.offlineWindow;
                    that.reloadDeptSections(_deptId);
                    that.gotoContact();
                    break;
                case 'rating_window':
                    _deptId = parseInt(data.previousDeptId !== undefined ? data.previousDeptId : data.deptId);
                    _config.offlineWindow = data.offlineWindow;
                    that.reloadDeptSections(_deptId);
                    _agentLeft = true;
                    _isRouting = false;
                    that.closeChat('postchat');
                    break;
                case 'return_to_bot':
                    if (_handoverInitiated === true) {
                        _handoverInitiated = false;
                        that.updateCookie('dept-id', _handoverOldChat.deptId);
                        _requestId = _handoverOldChat.requestId;
                        _config.offlineWindow = _handoverOldChat.offlineWindow;
                        that.updateCookie('chat-id', _handoverOldChat.chatId);

						_socket.emit('leave');
						_socket.emit('join', _handoverOldChat.chatId);

                        that.stopPing();
                        that.ping({
                            chat_id: _handoverOldChat.chatId,
							start_ping: 1,
                        });

                        if (_handoverOldChat.deptId !== _deptId) {
                            that.reloadDeptSections(_handoverOldChat.deptId);
                            lastInitDeptId = _handoverOldChat.deptId;
                        }

                        _deptId = parseInt(_handoverOldChat.deptId);

                        _isBot = true;

                        that.updateCookie('isRouting', false);
                        that.showContent('chat');
                    }
                    break;
            }
            _handoverInitiated = false;
        };

        this.startRouting = function() {
            if (_isRouting) {
                return;
            }

            if (_clientChat === undefined) {
                setTimeout(() => {
                    that.startRouting();
                }, 500);
                return;
            }

            const formSelector = 'form#' + _prechatFormId;
            let hasError = false;
            domHelper(formSelector + ' [data-chat-validation]').not('[data-chat-validation=""]').each((el) => {
                let $this = domHelper(el);
                if ($this.attr('required') === undefined && $this.val() === '') {
                    return true;
                }
                const regEx = new RegExp($this.data('chat-validation'));
                const $formGroup = $this.closest('.form-group');

                if ($this.prop('type') === 'radio') {
                    $this = domHelper("[name="+$this.prop('name')+"]:checked");
                }

                let valid;
                if ($this.prop('type') === 'checkbox') {
                    valid = regEx.test(String(domHelper("[name="+$this.prop('name')+"]:checked").length));
                } else {
                    valid = regEx.test(String($this.val()).trim());
                }

                $this.attr('aria-invalid', !valid);

                if (!valid) {
                    $formGroup.addClass('has-error');
                    hasError = true;
                    return;
                }

                $formGroup.removeClass('has-error');
            });

            if (hasError && _config.prechatEnabled) {
                return;
            }

            let videoSupport = that.readCookie('chime') === 'full';

            const data = Object.assign(
                {
                    ignore_bot: _ignoreBot,
                    display_width: screen.width,
                    display_height: screen.height,
                    is_webrtc: rp.chat.Core.getWebRTCDetected(),
                    pagename: rp.chat.Core.getPagename(),
                    page_url: rp.chat.Core.getCurrentUrl(),
                    initial_url: that.readCookie('initialUrl'),
                    mobile_device: _config.isMobile || 0,
                    invite_type: _invitetype,
                    sid_opti: rp.chat.Core.getSidOpti(),
                    businessrule_id: _businessRuleId || 0,
                    adblock_detected: (typeof rp.chat.Core.getAdBlockDetected === "function") ? rp.chat.Core.getAdBlockDetected() : 0,
                    save_transcript: domHelper(formSelector).find('#save-transcript').length ? domHelper(formSelector).find('#save-transcript').val() : 0,
                    timestamp: new Date(new Date + (rp.chat.Core.getTimeOffset() * 1000)).toJSON(),
                    video_support: videoSupport ? 1 : 0,
                    campaign_active: _config.campaign_active,
                    campaign_data: _config.campaign_active ? _config.campaign_data : []
                },
                that.objectifyForm(domHelper(formSelector)[0])
            );

            if (rpChatConfig.messengerToMobile !== undefined) {
                data.messenger_to_mobile = rpChatConfig.messengerToMobile;
            }

            if (rpChatConfig.mobileLink !== undefined && rpChatConfig.mobileLink.active) {
                data.name = rpChatConfig.mobileLink.customerName;
                data.profile_id = rpChatConfig.mobileLink.profileId;
                data.message = rpChatConfig.mobileLink.question;
                data.save_transcript = 1;
                data.previous_chat_id = rpChatConfig.mobileLink.previousChatId;
                data.previous_customer_id = rpChatConfig.mobileLink.previousCustomerId;
                data.previous_visitor_id = rpChatConfig.mobileLink.previousVisitorId;
                data.previous_profile_id = rpChatConfig.mobileLink.profileId;
                data.mobile_link = 1;
            }

            if (rpChatConfig.customerLanguage !== undefined) {
                data.customer_language = rpChatConfig.customerLanguage;
            }

            const formData = data;

            _isRouting = true;
            networkHelper.postJSON(_core.getEmbedApiBase() + '/request-chat/' + _deptId, data).then((data) => {
				(async function (data) {
                if (data.success) {
					await _clientChat.startChat(data.session_id);
					_socket.emit('join', data.session_id);
                    that.updateCookie('chat-id', data.session_id);
                    that.updateCookie('dept-id', _deptId);
                    triggerEvent(document, 'rp-chat-running');
                    _customerName = formData.name;
                    if (!_customerName) {
                        _customerName = window.rp.layer2_lang.CUSTOMER;
                    }
                    _requestId = data.request_id;
                    if (data.message && data.message.text !== '') {
                        that.processOutgoingMessage(data.message);
                    }

                    if (data.queueText && data.queueText != '') {
                        that.displayQueueText(data.queueText);
                    }

                    that.showContent('routing', true);
                    that.updateCookie('isRouting', true);
                    that.runRequestStateWorker();

                    if (that.readCookie('chime') !== undefined) {
                        // init chime meeting if needed
                        networkHelper.postJSON(_core.getEmbedApiBase() + '/chime-meeting-data', {
                            chatId: data.session_id
                        });
                    }

                    if (rp.chat.TrackModule !== undefined && rp.chat.TrackModule.createChatRequest !== undefined) {
                        rp.chat.TrackModule.createChatRequest();
                    }
                } else if (data.chatIsRunning !== undefined) {
                    // do nothing
                } else {
                    if (rp.chat.TrackModule !== undefined && rp.chat.TrackModule.noAgentAvailableOnPreChatSubmit !== undefined) {
                        rp.chat.TrackModule.noAgentAvailableOnPreChatSubmit();
                    }
                    that.gotoContact();
                }
				})(data);
            }).catch(() => {
                that.gotoContact();
            });

            rp.chat.Storage.remove("prechat");
            that.bindScrollEvents();
        }

        this.ping = function(options) {
            if (_agentLeft) {
                return;
            }
            networkHelper.postJSON(_core.getEmbedApiBase() + '/ping', options).then((data) => {
                if (data.chat_id != that.readCookie('chat-id')) {
                    return;
                }
                if (!data.chat_running) {
                    if (_agentLeft === undefined) {
                        let noticeMessage = window.rp.layer2_lang.CHAT_PARTYLEFTSESSION_AGENT;
                        noticeMessage = noticeMessage.replace(/%%agent%%/i, _agentIdentity.name);

                        that.processSystemNotice({
                            text: noticeMessage,
                            timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset()
                        });
                    }
                    domHelper('#' + _chatFormId).find('#message').prop('disabled', true);
                    domHelper('#' + _chatFormId).find('#send_button').prop('disabled', true);
                    that.swapMessageBoxForPdfButton();
                    return;
                } else if (data.agent_timeout) {
                    that.timeoutAgent();
                    return;
                }
                _pingTimer = setTimeout(() => {
                    delete options.start_ping;that.ping(options);
                }, _pingTimerTimeout);
            }).catch(() => {
                _pingTimer = setTimeout(() => {
                    that.ping(options);
                }, _pingTimerTimeout);
            });
        };

        this.stopPing = function() {
            if (_pingTimer !== undefined) {
                clearTimeout(_pingTimer);
                _pingTimer = undefined;
            }
        };

        this.gotoContact = function() {
            that.resetForm(_emailFormId);
            that.updateCookie('datasecurity', undefined);
            const prechatNameInput = domHelper('form#' + _prechatFormId + ' [name=name]').attr('rp-lang-value');
            if(prechatNameInput === 'undefined' || prechatNameInput === false) {
                domHelper('form#' + _emailFormId + ' [name=name]').val(domHelper('form#' + _prechatFormId + ' [name=name]').val());
            }
            domHelper('form#' + _emailFormId + ' [name=name]').val(domHelper('form#' + _prechatFormId + ' [name=name]').val());
            domHelper('form#' + _emailFormId + ' [name=email]').val(domHelper('form#' + _prechatFormId + ' [name=email]').val());
            domHelper('form#' + _emailFormId + ' [name=messagetext]').val(domHelper('form#' + _prechatFormId + ' [name=message]').val());
            that.showContent(_config.offlineWindow, true);
            that.resetForm(_prechatFormId);
            domHelper('#chat-conversation').html('');
            if (_clientChat.client != null && _clientChat.client.connected) {
                _clientChat.stopChat();
            }
            clearTimeout(_agentDisconnectedTimer);
            _agentDisconnectedTimer = undefined;
            _operatorMessageTimeouts.forEach(timeout => clearTimeout(timeout));
            _operatorMessageTimeouts = [];
            _agentLeft = undefined;
            _chatEnd = undefined;
            domHelper('#' +_chatFormId).find('#message').prop('disabled', true);
            that.updateCookie('unread', 0);
            that.updateCookie('saveTranscript', 1);
            that.stopPing();
            triggerEvent(document, 'rp-chat-ended');

            let contentView = "MissingView";
            switch (_config.offlineWindow) {
                case 'hotline':
                    contentView = 'status_button_hotline_max_capacity';
                    break;
                case 'contact':
                    contentView = 'status_button_contact_max_capacity';
                    break;
            }
            that.saveContentViews(contentView);
        }

        let _requestStateTimeout;
        this.runRequestStateWorker = function(callback) {
            if (!_requestId) return;

            _requestStateTimeout = setTimeout(() => {
                networkHelper.getJSON(_core.getEmbedApiBase() + '/request-state/' + _requestId, {}).then(async (data) => {
                    if (!data.response) {
                        that.updateCookie('isRouting', false);
                        if (typeof callback === 'function') {
                            callback();
                            return;
                        }

                        if (rp.chat.TrackModule !== undefined && rp.chat.TrackModule.checkAgent !== undefined) {
                            rp.chat.TrackModule.checkAgent(false);
                        }
                        that.gotoContact();
                        return;
                    }

                    var response = data.response;

                    if (!that.readCookie('chat-id')) {
                        return;
                    }

                    if (response.state === 'routed') {
                        if (Number(response.dept_id) !== Number(_deptId)) {
                            _deptId = response.dept_id;
                            that.reloadDeptSections(_deptId);
                            that.runRequestStateWorker(callback);
                            return;
                        }
                        that.updateCookie('isRouting', false);
                        that.showContent('chat', true);
                        if (!that.getMQTTIsConnected()) {
                            await _clientChat.startChat(that.readCookie('chat-id'));
                        }
                    }

                    if (!that.readCookie('isRouting')) {
                        return;
                    }
                    if (response.request_id != _requestId) {
                        return;
                    }

                    if (response.state === 'unknown' || response.state === 'no_agent_available') {
                        that.updateCookie('isRouting', false);

                        networkHelper.getJSON(_core.getEmbedApiBase() + '/unset-session', {});
                        if (typeof callback === 'function') {
                            callback();
                            return;
                        }
                        that.gotoContact();
                        return;
                    }
                    if (response.state === 'routing' || response.state === 'transfering') {
                        if (typeof callback === 'function' && response.profile_id == _agentIdentity.id) {
                            callback();
                            return;
                        }
                        that.runRequestStateWorker(callback);

                    }
                }).catch(() => {
                    that.updateCookie('isRouting', false);
                    if (typeof callback === 'function') {
                        callback();
                        return;
                    }
                    that.gotoContact();
                });
            }, 1000);
        };

        this.killRequestStateWorker = function(options) {
            that.updateCookie('isRouting', false);
            if (_requestStateTimeout !== undefined) {
                clearTimeout(_requestStateTimeout);
                _requestStateTimeout = undefined;
            }
        };

        this.objectifyForm = function(formElement) {
            return Object.fromEntries(new FormData(formElement).entries());
        };

        this.registerDragAndDrop = function() {
            let $dragging = null;
            const $handle = _chatWrapper.find('.drag-handle');
            const handleSelector = '#' + _chatWrapperId + ' > .drag-handle';
            let mousePosX;
            let mousePosY;
            let posX = that.readCookie('left');
            let posY = that.readCookie('top');

            if (!$handle.length) {
                return;
            }

            domHelper(window).on("resize", () => {
                _browserHeight = rp.chat.Core.getBrowserHeight();
                _browserWidth = rp.chat.Core.getBrowserWidth();

                that.setChatPosition(_chatWrapper, posX, posY);
            });

            domHelper(document).on("mousedown", handleSelector, (e) => {
                // no not handle if used on the control buttons
                if (domHelper(e.target).closest('.chat-controls').length) {
                    // debugger;
                    return;
                }

                // left mouse button
                if (e.which === 1 && !_chatWrapper.hasClass('minimized')) {
                    const handleRect = $handle[0].getBoundingClientRect();
                    mousePosX = e.pageX - handleRect.left - window.scrollX;
                    mousePosY = e.pageY - handleRect.top - window.scrollY;

                    document.body.style.userSelect = 'none';
                    $dragging = _chatWrapper;
                }
            }).on("mouseup", () => {
                if (!$dragging) {
                    return;
                }

                $dragging = null;
                document.body.style.userSelect = '';
            }).on("mousemove", (e) => {
                if ($dragging) {
                    posX = e.pageX - window.scrollX - mousePosX;
                    posY = e.pageY - window.scrollY - mousePosY;

                    that.setChatPosition(_chatWrapper, posX, posY);
                }
            });
        };

        this.setChatPosition = function($dragging, posX, posY) {
            const wrapperRect = _chatWrapper.getBoundingClientRect();
            _chatWrapperHeight = wrapperRect.height;
            _chatWrapperWidth = wrapperRect.width;

            // zu weit oben
            if (posY <= _snippingBufferTop) {
                posY = _snippingBufferTop;
            }
            // zu weit unten
            if (posY >= _browserHeight - _chatWrapperHeight) {
                let snippingBuffer = _snippingBuffer;
                if (_snippingBufferBottom !== undefined) {
                    snippingBuffer = _snippingBufferBottom;
                }
                posY = _browserHeight - _chatWrapperHeight - snippingBuffer;

                const bufferBottom = (rp.chat.Core.getConfig().position.bufferBottom === undefined) ? rp.chat.Core.getConfig().position.bufferBottom : 0;
                if (firstPositionSet === false && bufferBottom > 0) {
                    posY = posY - (bufferBottom - snippingBuffer);
                } else {
                    _chatWrapper.addClass('docked-bottom');
                }
            } else {
                _chatWrapper.removeClass('docked-bottom');
            }

            // zu weit links
            if (posX <= _snippingBuffer) {
                posX = _snippingBuffer;
            }

            // zu weit rechts
            if (posX + _chatWrapperWidth + _snippingBuffer >= _browserWidth) {
                posX = _browserWidth - _chatWrapperWidth - _snippingBuffer;
                if (posX < _snippingBuffer) {
                    posX = _snippingBuffer;
                }

                const bufferRight = (rp.chat.Core.getConfig().position.bufferRight !== undefined) ? rp.chat.Core.getConfig().position.bufferRight : 0;
                if (firstPositionSet === false && bufferRight > 0) {
                    posX = posX - (bufferRight - _snippingBuffer);
                }
            }

            $dragging[0].style.position = 'fixed';
            $dragging[0].style.top = posY + 'px';
            $dragging[0].style.left = posX + 'px';

            that.updateCookie('left', posX);
            that.updateCookie('top', posY);

            firstPositionSet = true;
        };

        /**
         * intern
         */
        this.readCookie = function(index) {
            const cookie = Cookies.getJSON(_cookieName) || _cookieContent;
            if (index === undefined) {
                return cookie;
            }
            return cookie[index];
        };

        /**
         * intern
         */
        this.updateCookie = function(index, value) {
            if (rp.chat.LayerChat.canStoreCookies()) {
                _cookies = Cookies.getJSON(_cookieName) || _cookieContent;
                _cookies[index] = value;
                const cookieSettings = {
                    path: '/',
                    domain: rp.chat.Core.getFirstDomainName(),
                    secure: window.location.protocol === 'https:',
                    sameSite: 'lax'
                };
                Cookies.set(_cookieName, _cookies, cookieSettings);
            }
        };

        this.removeCookie = function(cookieName = _cookieName) {
            Cookies.remove(cookieName, {
                path: '/',
                domain: rp.chat.Core.getFirstDomainName()
            });
        };

        this.canStoreCookies = function() {
            const config = rp.chat.Core.getConfig();
            return (
                (config.requireCookieConsent === false)
                || (config.requireCookieConsent === true && rpChatConfig.checkTrackingAllowed())
            );
        }

        this.addFeatureToChimeCookie = function(feature) {
            let chimeCookie = that.readCookie('chime');
            if (!!chimeCookie && chimeCookie.length > 0) {
                chimeCookie = 'audio-screenshare';
            } else {
                chimeCookie = feature;
            }
            that.updateCookie('chime', chimeCookie);
        }

        this.removeFromChimeCookie = function(feature) {
            let chimeCookie = that.readCookie('chime');
            if (!!chimeCookie && chimeCookie.includes(feature)) {
                chimeCookie = chimeCookie.replace(feature, '');
                chimeCookie = chimeCookie.replace('-', '');
            }

            if (chimeCookie.length === 0) {
                chimeCookie = undefined
            }

            that.updateCookie('chime', chimeCookie);
        }

        this.hasActiveChimeCookie = function(feature) {
            let chimeCookie = that.readCookie('chime');
            return !!chimeCookie && chimeCookie.includes(feature);
        }

        this.uuidv4 = function () {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        }

        this.sendToSocket = function (event, arg1, arg2, arg3) {
            if (_clientChat !== undefined) {
                const data = {
                    event: event,
					messageId: this.uuidv4(),
                    arg1: arg1,
                    arg2: arg2,
                    arg3: arg3
                };
                dataStoreToSocket.push(data);
                this.deliverDataToSocket(data, 0);
            }
        }

        this.deliverDataToSocket = function (data, counter) {
            if (dataStoreToSocket.some(e => e.messageId === data.messageId)) {
				_clientChat.sendMessage({type: data.event, payload: {messageId: data.messageId}});
                _socket.emit(data.event, data.messageId);
                if (counter * RETRY_DELIVER_CHAT_MESSAGE_MS < MAX_TIME_TO_DELIVER_A_MESSAGE) {
                    setTimeout(() => this.deliverDataToSocket(data, ++counter), RETRY_DELIVER_CHAT_MESSAGE_MS);
                } else {
                    this.successfullyDeliveredDataToSocket(data.messageId);
                }
            }
        }

        this.successfullyDeliveredDataToSocket = function (messageId)
        {
            dataStoreToSocket = dataStoreToSocket.filter(function(data) {
                return data.messageId !== messageId;
            })
        }

        /**
         * intern
         */
        this.showContent = function(id, updateCookie, callback, isClosed) {
            if (delayRoutingWindowTimeout) {
                clearTimeout(delayRoutingWindowTimeout);
            }

            if (id === 'chat') {
                that.updateCookie('skip-postchat', false);
            }

            const elem = _chatWrapper.find(_sectionTag + '#' + id);
            const section = _chatWrapper.find(_sectionTag);
            const chatBody = _chatWrapper.find('.chat-body');

            if ((id === 'routing' || (id === 'prechat' && isClosed)) && _sectionActive === 'prechat') {
                that.saveContentViews('prechat-close');
            }
            _sectionActive = id;
            _isRouting = id === 'routing';

            if (isClosed) {
                chatBody.removeAttr('aria-live');
            }

            if (elem.length) {
                if (_sectionActive !== 'close') {
                    _chatWrapper.addClass(_sectionActive);
                }

                section.not(elem)
                    .each(function(index, el) {
                        const sectionId = el.id;
                        if (_chatWrapper.hasClass(sectionId)) {
                            _chatWrapper.removeClass(sectionId);
                        }
                    })
                    .hide();

                elem
                    .each(el => el.style.display = 'flex')
                    .fadeIn(_fadeInTime, () => {
                        elem.find('.default-focus').first().trigger('focus');
                    });

                if (updateCookie) {
                    that.updateCookie('window', id);
                }
            }

            if (id === 'postchat') {
                if (rp.chat.Cobrowsing2) rp.chat.Cobrowsing2.close();
            }
            that.loadDepencies(id);

            if (typeof callback === "function") {
                callback();
            }
        };

        /**
         * intern
         */
        this.saveContentViews = function(index) {


            if (lastContentView === index) {
                lastContentViewCounter++;
                return
            }
            lastContentView = index;

            const data = {
                type: index,
                is_mobile: !!_config.isMobile,
                origin: _invitetype,
                campaign: _config.campaign_active ? _config.campaign_data : [],
                contentViewCounter: lastContentViewCounter
            };
            lastContentViewCounter = 0;
            networkHelper.postJSON(_core.getEmbedApiBase() + '/content-views/' + _deptId, data);
        };

        this.resetChat = function() {

        };

        this.closePreChat = function () {
            const content = that.readCookie('window');
            if (content === 'prechat') {
                that.updateCookie('dept-id', 0);
                _deptId = rp.chat.Core.getDeptId();
                that.updateCookie('closed', true);
            }
        };

        this.closeChat = function(targetContent) {
            const that = this;
            let chat_id = that.readCookie('chat-id');
            targetContent = targetContent || 'postchat';

            networkHelper.getJSON(_core.getEmbedApiBase() + '/ischatting').then((data) => {
                if (rp.chat.Core.getConfig().noInteractionSkipPostChat === true && data.events && data.events.filter(event => event.type === 'outgoing').length === 0) {
                    that.updateCookie('skip-postchat', true);
                }
                if(data.is_chatting == true || !!_agentLeft) {
                    networkHelper.getJSON(_core.getEmbedApiBase() + '/exit-chat', {
                        chat_id: chat_id
					}).then(() => {

                        that.resetForm(_prechatFormId);
                        that.resetForm(_postchatFormId);
                        that.updateCookie('datasecurity', undefined);
                        domHelper('#chat-conversation').html('');
                        domHelper('#'+_chatFormId+' #message').removeProp('disabled');
                        domHelper('#'+_chatFormId).removeClass('hide');
                        if (_socket !== undefined) {
                            _socket.emit('leave');
                        }
                        if (_clientChat != null && _clientChat.client != null) {
                            _clientChat.stopChat();
                        }
                        _operatorMessageTimeouts.forEach(timeout => clearTimeout(timeout));
                        _operatorMessageTimeouts = [];
                        clearTimeout(_agentDisconnectedTimer);
                        _agentDisconnectedTimer = undefined;
                        _agentLeft = undefined;
                        _chatEnd = undefined;
                        domHelper('#' +_chatFormId).find('#message').prop('disabled', true);
                        _chatWrapper.find('#inputarea').removeClass('botShowInput');
                        that.updateCookie('botShowInput', null);
                        _chatWrapper.removeClass('isBot');
                        _chatWrapper.removeClass('botHideInput');
                        that.updateCookie('unread', 0);
                        that.stopPing();
                        that.updateCookie('chime', undefined);
                        triggerEvent(document, 'rp-chat-ended');

                        if(_agentIdentity && !_isRouting && !that.readCookie('skip-postchat')
                            && (targetContent === 'postchat' && that.readCookie('window') !== 'postchat')
                        ) {
                            that.showContent(targetContent, true);
                            that.updateCookie('prev-window', undefined);
                        } else {
                            that.hideChat(function() {
                                that.showContent('prechat', true, null, true);
                                _deptId = rp.chat.Core.getDeptId();
                                that.reloadDeptSections(_deptId);
                                that.removeCookie();
                                triggerEvent(document, 'rp-layer-closed');
                            });
                        }
                        rp.chat.Storage.destroy();
                    });
                } else {
                    _chatWrapper.fadeOut(_fadeOutTime, function() {
                        that.resetForm(_prechatFormId);
                        that.resetForm(_postchatFormId);
                        domHelper('#chat-conversation').html('');
                        if (_clientChat.client != null && _clientChat.client.connected) {
                            _clientChat.stopChat();
                        }
                        clearTimeout(_agentDisconnectedTimer);
                        _agentDisconnectedTimer = undefined;
                        _operatorMessageTimeouts.forEach(timeout => clearTimeout(timeout));
                        _operatorMessageTimeouts = [];
                        that.showContent('prechat', true, null, true);
                        _deptId = rp.chat.Core.getDeptId();
                        that.reloadDeptSections(_deptId);
                        that.removeCookie();
                        triggerEvent(document, 'rp-layer-closed');
                    });
                    networkHelper.getJSON(_core.getEmbedApiBase() + '/unset-session', {}).then(() => {
                        _deptId = rp.chat.Core.getDeptId();
                        that.removeCookie();
                        that.stopPing();
                    });
                }
            }).then(function() {

            leaveChimeMeeting();

            _isRunning = false;
        });
		};

        /**
         * intern
         */
        this.toggleLayer = function(callback) {
            if (that.readCookie('minimized')) {
                that.maximizeLayer();
                that.scrollToLastMessage();
            } else {
                that.minimizeLayer();
                triggerEvent(document, 'rp-unread-messages');
                const unread = that.readCookie('unread');
                if (unread > 0) {
                    triggerEvent(document, 'rp-unread-messages', {
                        count: unread
                    });
                }
            }

            if (typeof callback === "function") {
                callback(that.readCookie('minimized'));
            }
        };

        /**
         * intern
         */
        this.maximizeLayer = function() {
            if (_chatWrapper == null) {
                return false;
            }

            _chatWrapper.removeClass('minimized');
            that.updateCookie('minimized', false);

            that.markAllAsRead();
        };

        /**
         * intern
         */
        this.markAllAsRead = function() {
            that.updateCookie('unread', 0);
            triggerEvent(document, 'rp-unread-messages', {
                count: that.readCookie('unread')
            });
        };

        /**
         * intern
         */
        this.minimizeLayer = function() {
            if (_chatWrapper == null) {
                return false;
            }

            _chatWrapper.addClass('minimized');
            that.updateCookie('minimized', true);
        };


        this.removeCloseButton = function() {
            _chatCloseButton.addClass('hide');
        };

        this.showCloseButton = function() {
            _chatCloseButton.removeClass('hide');
        };

        /**
         * extern (loadchatmodule.js) muss als Integer zurueckgegeben werden
         */
        this.getChatLayerIsActive = function() {
            return that.readCookie('closed') ? 0 : 1;
        };

        this.getSocketIsConnected = function() {
            return !(
                typeof _socket === "undefined"
                || typeof _socket.connected === "undefined"
                || !_socket.connected
            );
        }

        this.setReloadChatContent = function() {
            _reloadChatContent = true;
        }

		this.getMQTTIsConnected = function() {
			return !(!_clientChat || !_clientChat.client);
		};

        this.getIsChimeActive = function() {
            return !! that.readCookie('chime');
        };

        this.processTranscriptEvents = function(events) {
            events.forEach((event) => {
                switch (event.type) {
                    case 'incoming':
                        if (event.text === '') return;
                        that.processIncomingMessage({
                            name: event.name,
                            timestamp: event.timestamp,
                            text: event.text,
                            isTranslation: !!event.isTranslation,
                        });
                        break;
                    case 'outgoing':
                    case 'entry-question':
                        if (event.text === '') return;
                        that.processOutgoingMessage({
                            name: event.name,
                            timestamp: event.timestamp,
                            text: event.text,
                        });
                        break;
                    case 'notice':
                    case 'system-info':
                        if (event.text === '') return;
                        that.processSystemNotice({
                            timestamp: event.timestamp,
                            text: event.text,
                        });
                        break;
                    case 'rating':
                        if (event.text === '') return;
                        that.processSystemInfo({
                            timestamp: event.timestamp,
                            text: event.text,
                        });
                        break;
                    case 'connected':
                        if (event.text === '') return;
                        that.processSystemInfo({
                            text: event.text,
                        });
                        break;
                    case 'exit':
                        domHelper('#' + _chatFormId).find('#message').prop('disabled', true);
                        domHelper('#' + _chatFormId).find('#send_button').prop('disabled', true);
                        that.swapMessageBoxForPdfButton();
                        _agentLeft = true;
                        break;
                    case 'exit-chat':
                        domHelper('#' + _chatFormId).find('#message').prop('disabled', true);
                        domHelper('#' + _chatFormId).find('#send_button').prop('disabled', true);
                        that.swapMessageBoxForPdfButton();
                        _agentLeft = true;
                        if (event.text !== '') {
                            that.processSystemInfo({
                                text: event.text,
                            });
                        }
                        break;
                }
            });
        };

        this.processAgentIdentity = function(identity) {
            if (identity.bot_config) {
                _chatWrapper.addClass('isBot');
                that.updateCookie('agentLeft', 0);
				_chatWrapper.find('#message').prop('disabled', false);
                that.swapPdfButtonForMessageBox();
                if (identity.bot_config.frontend_hide_input) {
                    _chatWrapper.addClass('botHideInput');
                    if (that.readCookie('botShowInput')) {
                        _chatWrapper.find('#inputarea').addClass('botShowInput');
                    }
                } else {
                    _chatWrapper.removeClass('botHideInput');
                }
				if (identity.bot_config.limit_input_length) {
					_chatWrapper.find('#message').attr('maxlength', identity.bot_config.limit_input_length);
				} else {
					_chatWrapper.find('#message').removeAttr('maxlength');
                }
            } else {
                _chatWrapper.removeClass('isBot');
                _chatWrapper.removeClass('botHideInput');
                domHelper('#' + _chatFormId).find('#message').prop('disabled', !!_agentLeft);
                if (_agentLeft) {
                    that.swapMessageBoxForPdfButton();
                } else {
                    that.swapPdfButtonForMessageBox();
                }
            }

            if (identity.picture) {
                // fix internal url
                identity.picture = identity.picture.replace(/^https?:\/\/frontend\/system/, _collectUrl);

                _chatWrapper.find('.agent-picture').prop('src', identity.picture);
                _chatWrapper.find('#chat').find('.header').addClass('header-w-pic');
                _chatWrapper.find('.picture').removeClass('hidden');

                _chatWrapper.find('.data-agent-picture').attr('data-agent-picture', identity.picture);
                _chatWrapper.find('i.background-agent-picture').each(el => el.style.backgroundImage = 'url(' + identity.picture + ')');
                _chatWrapper.find('.agent-picture.background-agent-picture').last().each(el => el.style.backgroundImage = 'url(' + identity.picture + ')');
                _chatWrapper.find('.operator-picture.background-agent-picture').last().each(el => el.style.backgroundImage = 'url(' + identity.picture + ')');
            } else {
                _chatWrapper.find('#chat').find('.header').removeClass('header-w-pic');
                _chatWrapper.find('.picture').addClass('hidden');
            }

            _chatWrapper.find('.header .agent-name').text(identity.name);
            _chatWrapper.find('.data-agent-name').prop('data-agent-name', identity.name);

            _agentIdentity = identity;

            triggerEvent(document, 'rp-agent-identity', {
                name: identity.name,
                picture: !identity.picture ? undefined : identity.picture,
                transfer: identity.transfer,
                paymentGroupId: identity.paymentgroup_id,
                paymentGroupTeamId: identity.payment_group_team_id,
            });
        };

        this.processOutgoingMessage = function (message, callback) {
            const $outgoingMessage = domHelper('section#templates #template-message-outgoing > *').clone();
            const customerName = cleanHtml(message.name);
			const messageContent = cleanHtml(message.text);

			$outgoingMessage.find('.customer').html(customerName);
            const timestampDateformat = $outgoingMessage.find('.time').data('date-format');
            $outgoingMessage.find('.time').html(timestampDateformat ? dateFormat(new Date(parseInt(message.timestamp) * 1000), timestampDateformat) : message.timestamp);
            $outgoingMessage.find('.text').html(messageContent).find('a').prop('target', '_blank');
            domHelper('#chat-conversation .typing').remove();
            $outgoingMessage.appendTo('#chat-conversation');

            if (typeof callback === "function") {
                callback($outgoingMessage);
            }
        }

        this.processIncomingMessage = function (message, callback) {
            const $incomingMessage = domHelper('section#templates #template-message-incoming > *').clone();

            const operatorName = cleanHtml(message.name);
            let messageContent = cleanHtml(message.text);

            $incomingMessage.find('.operator').html(operatorName);
            if (operatorName === '') {
                $incomingMessage.find('.operator').addClass('hidden');
                $incomingMessage.find('.text').addClass('left');
            }
            const timestampDateformat = $incomingMessage.find('.time').data('date-format');
            $incomingMessage.find('.time').html(timestampDateformat ? dateFormat(new Date(parseInt(message.timestamp) * 1000), timestampDateformat) : message.timestamp);

            if (message.isTranslation) {
                messageContent += `<span class="translation-bubble" title="` + window.rp.layer2_lang.TRANSLATED + `"><i class="translation-icon"></i></span>`;
            }

            if (messageContent.includes('js-accept-language') && that.readCookie('useTranslation') === 1) {
                messageContent = messageContent.replace(/<div class="buttons">.*?<\/div>/, '');
            }

            $incomingMessage.find('.text').html(messageContent).find('a').prop('target', '_blank');
            if ($typingLogElement && $typingLogElement.length > 0) {
                $typingLogElement.remove();
                $typingLogElement = undefined;
            }

            $incomingMessage.appendTo('#chat-conversation');
            if (domHelper('.scroll-down-button').isVisible()) {
                domHelper('.scroll-down-button i').removeClass('rp-icon-ios-more');
                if (domHelper('#chat-conversation.content').length > 0) {
                    domHelper('.scroll-down-button i').addClass('rp-arrow-down-icon');
                } else {
                    domHelper('.scroll-down-button i').addClass('rp-icon-chevron-down');
                }
                const unread = that.readCookie('unread') + 1;
                that.updateCookie('unread', unread);
                triggerEvent(document, 'rp-unread-messages-scroll-down');
            } else {
                setTimeout(that.scrollToLastMessage, 100);
            }
            if (typeof callback === "function") {
                callback($incomingMessage);
            }
        }

        this.processIncomingBotMessage = function (message, callback) {
            const $incomingBotMessage = domHelper('section#templates #template-message-incoming > *').clone();
            const operatorName = cleanHtml(message.name);
			const messageContent = cleanHtml(message.text);

			$incomingBotMessage.find('.operator').html(operatorName);
            const timestampDateformat = $incomingBotMessage.find('.time').data('date-format');
            $incomingBotMessage.find('.time').html(timestampDateformat ? dateFormat(new Date(parseInt(message.timestamp)), timestampDateformat) : message.timestamp);
            $incomingBotMessage.find('.text').html(messageContent);
            domHelper('#chat-conversation .typing').remove();
            $incomingBotMessage.appendTo('#chat-conversation');

            if(typeof callback === "function") {
                callback($incomingBotMessage);
            }
        }

        this.processQuickReplies = function (quickReplies, quickRepliesType, callback) {
            const $quickReplies = domHelper('section#templates #template-quick-replies > *').clone();
            quickReplies.forEach((quickReply) => {
                let el;
                if (quickRepliesType === 'list') {
                    el = document.createElement('div');
                    el.classList.add('list', 'btn-primary');
                } else {
                    el = document.createElement('button');
                    el.classList.add('btn', 'btn-primary');
                }
                el.style.backgroundColor = quickReply.color;
                el.style.borderColor = quickReply.color;
                el.style.color =  quickReply.fontColor;

                if (quickReply.metaData && quickReply.metaData.length) {
                    quickReply.metaData.forEach(metaData => {
                        el.dataset[metaData.key] = metaData.value;
                    });
                }

                const $el = domHelper(el);
                $el.attr('data-chat-event', 'rp-quick-reply');
                $el.attr('data-quick-reply-title', removeHTML(quickReply.title));
                $el.attr('tabindex', 0);

                if (quickReply.type) {
                    $el.attr('data-type', quickReply.type);
                }
                if (quickReply.payload) {
                    $el.attr('data-payload', quickReply.payload);
                }
                $el.text(quickReply.title);
                $el.appendTo($quickReplies);
            });
            $quickReplies.appendTo('#chat-conversation');

            triggerEvent(document, 'rp-quick-replies-rendered');

            if (typeof callback === "function") {
                callback($quickReplies);
            }
        }

        this.destroyQuickReplies = function () {
            domHelper('#chat-conversation .quick-replies').remove();
        }

        this.processAction = function (action, callback) {
            switch (action.name) {
                case 'finished':
                    that.stopPing();
                    domHelper('#'+_chatFormId+' #message').prop('disabled', true);
                    domHelper('#chat-conversation button').prop('disabled', true);
                    domHelper('#'+_chatFormId).addClass('hide');
                    networkHelper.getJSON(_core.getEmbedApiBase() + '/exit-chat', {}).then(() => {
                        rp.chat.Storage.destroy();
                    });
                    break;
                case 'availability':
                    that.botCheckAvailability(action.payload, function (data) {
                        that.botSendInternalMessage(data.available ? 'agent_available' : 'agent_not_available', function (data) {
                            that.scrollToLastMessage();
                        });
                    });
                    break;
                case 'terminate':
                    setTimeout(function () {
                        triggerEvent(document, 'rp-exit-chat')
                    }, 5000);
                    break;
                case 'show-input':
                    triggerEvent(document, 'rp-bot-show-input-once');
                    break;
                case 'show-footnote':
                    triggerEvent(document, 'rp-bot-show-footnote-once', action.payload);
                    break;
                case 'show-data-privacy':
                    triggerEvent(document, 'rp-bot-show-data-privacy', action.payload);
                    that.updateCookie('botDataPrivacy', action.payload);
                    break;
                case 'show-rating':
                    that.updateCookie('show-rating-active', action.payload);
                    triggerEvent(document, 'rp-bot-show-rating', action.payload);
                    break;
                case 'terminate-contact':
                    triggerEvent(document, 'rp-exit-chat', action.name);
                    break;
                default:
            }

            if (typeof callback === "function") {
                callback();
            }
        }

        this.processSearchReply = function (searchReply) {
            let topSearchReply = document.querySelector('#search-reply .top-search-reply ul.top-search-reply-list');
            while (topSearchReply.firstChild) {
                topSearchReply.removeChild(topSearchReply.firstChild);
            }
            let searchCancelButton = document.querySelector('#search-reply .search-reply-wrapper button');
            if (searchCancelButton && searchReply) {
                const hasCancelButton = that.botSearchReply?.hasCancelButton ?? false;
                searchCancelButton.style.display = hasCancelButton ? 'inline-block' : 'none';
            }

            searchReply.searchList.forEach(function(value, key) {
                let elem = document.createElement('li');
                elem.textContent = value;
                elem.dataset.name = value;

                elem.addEventListener('click', function(e) {
                    const data = {
                        name: _customerName,
                        timestamp: Math.floor(new Date / 1000),
                        text: value + '|search_reply_response',
                        isBot: true,
                        session_rp: _visitorId,
                        isSearchReply: true,
                    };

                    networkHelper.postJSON(_core.getEmbedApiBase() + '/send-message/' + that.readCookie('chat-id'), data).then(function (data) {
                        that.processOutgoingMessage(data);
                        that.scrollToLastMessage();
                        _chatWrapper.find('#search-input').val('');
                        that.showContent('chat', true);
                    });
                });

                topSearchReply.appendChild(elem);
            });

            if (searchReply.additionalText) {
                const titleObject = searchReply.additionalText.find(item => item.hasOwnProperty('title'));
                const sectionTitle = titleObject ? titleObject.title : _chatWrapper.find('section#search-reply[data-title]').data('title') || '';
                if (typeof sectionTitle !== "undefined") {
                    _chatWrapper.find('.chat-header .chat-title').text(sectionTitle);
                }

                const inputPlaceholderObject = searchReply.additionalText.find(item => item.hasOwnProperty('inputPlaceholder'));
                if (typeof inputPlaceholderObject !== "undefined") {
                    _chatWrapper.find('#search-reply-list #search-reply-input')[0].placeholder = inputPlaceholderObject.inputPlaceholder;
                }
            }

        }

        this.reloadDeptSections = function(deptId) {
            networkHelper.getJSON(_core.getEmbedApiBase() + '/load-content/' + deptId).then((data) => {
                contentData = data;

                networkHelper.loadText(versionizeUrl(_collectUrl + '/layouts/' + rp.chat.Core.getConfig().theme + '/html/index.html')).then((data) => {
                    const shadow = document.createElement('div');
                    shadow.innerHTML = data;

                    let disableToSendMessages = false;
                    if (document.querySelector('#' + _chatWrapperId + ' #send_button') !== null) {
                        if (document.querySelector('#' + _chatWrapperId + ' #send_button').disabled == true) {
                            disableToSendMessages = true;
                        }
                    }
                    if (document.querySelector('#' + _chatWrapperId + ' #message') !== null) {
                        if (document.querySelector('#' + _chatWrapperId + ' #message').disabled == true) {
                            disableToSendMessages = true;
                        }
                    }
                    processTemplate(
                        shadow,
                        _collectUrl + '/layouts/' + rp.chat.Core.getConfig().theme,
                        contentData.language,
                        contentData.features,
                        contentData.infoBlocks,
                        contentData.prechatFields,
                        contentData.contactFields,
                        contentData.survey
                    );
                    that.reloadLanguages();
                    _chatWrapper.find('#postchat').html(shadow.querySelector('#postchat').innerHTML);

                    let footer = shadow.querySelector('.chat-footer');
                    if (footer) {
                        _chatWrapper.find('.chat-footer').html(footer.innerHTML);
                    }

                    let contact = shadow.querySelector('#contact');
                    if (contact) {
                        _chatWrapper.find('#contact').html(contact.innerHTML);
                    }

                    let hotline = shadow.querySelector('#hotline');
                    if (hotline) {
                        _chatWrapper.find('#hotline').html(hotline.innerHTML);
                    }


                    let featureDefaultTheme = shadow.querySelector('#chat .buttons');
                    if (featureDefaultTheme) {
                        _chatWrapper.find('#chat .buttons').html(featureDefaultTheme.innerHTML);
                        if (document.querySelector('#' + _chatWrapperId + ' #send_button') !== null) {
                            document.querySelector('#' + _chatWrapperId + ' #send_button').disabled = disableToSendMessages;
                        }
                    }

                    let featureDefaultThemeInputarea = shadow.querySelector('#chat #inputarea');
                    if (featureDefaultThemeInputarea) {
                        _chatWrapper.find('#chat #inputarea').html(featureDefaultThemeInputarea.innerHTML);
                        if (document.querySelector('#' + _chatWrapperId + ' #message') !== null) {
                            document.querySelector('#' + _chatWrapperId + ' #message').disabled = disableToSendMessages;
                        }
                    }

                    let feature2020Theme = shadow.querySelector('.footer .chat-controls');
                    if (feature2020Theme) {
                        _chatWrapper.find('.footer .chat-controls').html(feature2020Theme.innerHTML);
                    }

                    addDynamicInputFields(contentData.prechatFields, '#realpersonPreChatDynamicInputPrototype');
                    addDynamicInputFields(contentData.contactFields, '#realpersonContactDynamicInputPrototype');
                    intializeUploader();
                });});
        };

        this.reloadLanguages = function(languageCodeIso) {
            if (that.readCookie('useTranslation') === 0) {
                return;
            }

            const data = {
                chat_id: that.readCookie('chat-id'),
                language_iso: languageCodeIso || '',
            };

            networkHelper.postJSON(_core.getEmbedApiBase() + '/confirm-language', data).then((data) => {
                if (typeof data !== 'object' || data === null) {
                    data = {};
                }
                let localTranslations = {};
                Object.entries(data).forEach(([key, message]) => {
                    let newKey = key.replace(/::/g, '_').toUpperCase();
                    newKey = newKey.replace(/-/g, '_');
                    localTranslations[newKey] = message;
                });

                window.rp.layer2_lang.CHAT_PARTYLEFTSESSION_AGENT = localTranslations['INDEX_AGENT_LEFT_SESSION'];
                window.rp.layer2_lang.CHAT_PARTYLEFTSESSION_TIMEOUT = localTranslations['INDEX_SESSION_TIMEOUT_AGENT'];
                window.rp.layer2_lang.CHAT_PARTYLEFTSESSION_IDLE = localTranslations['INDEX_SESSION_INACTIVE'];
                window.rp.layer2_lang.IS_TYPING = localTranslations['INDEX_IS_TYPING'];
                window.rp.layer2_lang.CUSTOMER = localTranslations['INDEX_PLACEHOLDER_NAME'];
                window.rp.layer2_lang.FILE_TOO_LARGE = localTranslations['INDEX_FILE_UPLOAD_FILE_TOO_LARGE'];
                window.rp.layer2_lang.FILE_TYPE_NOT_ALLOWED = localTranslations['INDEX_FILE_UPLOAD_FILE_TYPE_NOT_ALLOWED'];
                window.rp.layer2_lang.FILE_UPLOAD_FAILED = localTranslations['INDEX_FILE_UPLOAD_UPLOAD_FAILED'];
                window.rp.layer2_lang.FILE_CHECKING_FILE = localTranslations['INDEX_FILE_UPLOAD_CHECKING_FILE'];
                window.rp.layer2_lang.FILE_SUCCESS = localTranslations['INDEX_FILE_UPLOAD_SUCCESS'];
                window.rp.layer2_lang.COBROWSING_USER_ACCEPT = localTranslations['COBROWSING_COBROWSING_TRANSCRIPT_CAPTION_USER_ACCEPT'];
                window.rp.layer2_lang.COBROWSING_ACCEPT_WAIT = localTranslations['COBROWSING_COBROWSING_MOMENT_WAIT'];
                window.rp.layer2_lang.COBROWSING_CLOSE_BY_CUSTOMER = localTranslations['COBROWSING_CLOSE_BY_CUSTOMER'];
                window.rp.layer2_lang.DATASECURITY_ACCEPT_RESPONSE = localTranslations['DATA_PRIVACY_ACCEPT_RESPONSE'];
                window.rp.layer2_lang.DATASECURITY_DENY_RESPONSE = localTranslations['DATA_PRIVACY_DENY_RESPONSE'];
                window.rp.layer2_lang.FILE_UPLOAD_TITLE = localTranslations['CHAT_FILE_UPLOAD'];
                window.rp.layer2_lang.MESSAGE_WAS_NOT_DELIVERED = localTranslations['INDEX_SOCKET_MESSAGE_WAS_NOT_DELIVERED'];
                window.rp.layer2_lang.SCREENSHARE_ACCEPT_WAIT = localTranslations['SCREENSHARE_SCREENSHARE_MOMENT_WAIT'];
                window.rp.layer2_lang.VOICE_ACCEPT_WAIT = localTranslations['VOICE_VOICE_MOMENT_WAIT'];
                window.rp.layer2_lang.VOICE_ENDED = localTranslations['VOICE_VOICE_ENDED'];
                window.rp.layer2_lang.TRANSLATED = localTranslations['CHAT_TRANSLATED'];
            });
        }

        this.processSystemNotice = function (message, callback) {
            const $systemNotice = domHelper('section#templates #template-message-system-notice > *').clone();
            const messageContent = cleanHtml(message.text);

			$systemNotice.find('.text').html(messageContent);
            const timestampDateformat = $systemNotice.find('.time').data('date-format');
            $systemNotice.find('.time').html(timestampDateformat ? dateFormat(new Date(parseInt(message.timestamp) * 1000), timestampDateformat) : message.timestamp);
            $systemNotice.appendTo('#chat-conversation');

            if (typeof callback === "function") {
                callback($systemNotice);
            }
        }

        this.processSystemInfo = function (message, callback) {
            const $systemInfo = domHelper('section#templates #template-message-system-info > *').clone();
            const messageContent = cleanHtml(message.text);

			$systemInfo.find('.text').html(messageContent);
            $systemInfo.appendTo('#chat-conversation');

            if (typeof callback === "function") {
                callback($systemInfo);
            }
        }

        this.displayQueueText = function (message) {
            const queueSelector = '#' + _chatWrapperId + ' .routing-message-queue';
            const routingQueue = document.querySelector(queueSelector);
            if (routingQueue) {
                routingQueue.innerHTML = message;
                routingQueue.classList.remove('hidden');

                setTimeout(this.hideQueueText, 30000);
            }
        }

        this.hideQueueText = function (message) {
            const queueSelector = '#' + _chatWrapperId + ' .routing-message-queue';
            const routingQueue = document.querySelector(queueSelector);
            if (routingQueue) {
                routingQueue.classList.add('hidden');
            }
        }

        let $typingLogElement;
        this.showTypingMessage = function (display) {
            if (display) {
                if (domHelper('.scroll-down-button').isVisible()) {
                    domHelper('.scroll-down-button i')
                        .removeClass('rp-icon-chevron-down')
                        .removeClass('rp-arrow-down-icon')
                        .addClass('rp-icon-ios-more');
                } else {
                    const $typing = domHelper('#chat-conversation .typing');
                    if ($typing.length > 0) {
                        $typing.find('.text').html(window.rp.layer2_lang.IS_TYPING);
                        $typing.find('.agent-name').html(_agentIdentity.name);
                        $typing.each(el => el.style.visibility = 'visible');
                    } else {
                        $typingLogElement = domHelper('section#templates #template-typing > *').clone();
                        $typingLogElement.find('.text').html(window.rp.layer2_lang.IS_TYPING);
                        $typingLogElement.appendTo('#chat-conversation');
                        that.scrollToLastMessage();
                    }
                }
            } else {
                if (domHelper('.scroll-down-button').isVisible()) {
                    domHelper('.scroll-down-button i').removeClass('rp-icon-ios-more');
                    if (domHelper('#chat-conversation.content').length > 0) {
                        domHelper('.scroll-down-button i').addClass('rp-arrow-down-icon');
                    } else {
                        domHelper('.scroll-down-button i').addClass('rp-icon-chevron-down');
                    }
                }
                if ($typingLogElement && $typingLogElement.length > 0) {
                    $typingLogElement.each(el => el.style.visibility = 'hidden');
                }
            }
        };

        this.botSendInternalMessage = function (message, callback) {
            callback = callback || function (data) {};
            const chatId = that.readCookie('chat-id');
            that.destroyQuickReplies();
            networkHelper.postJSON(_core.getEmbedApiBase() + '/send-message/' + chatId, {
                name: _customerName,
                timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset(),
                text: message,
                dept_id: _deptId,
                chat_id: chatId,
                no_save: true
            }).then(callback);
        }

        this.botCheckAvailability = function (data, callback) {
            callback = callback || function (data) {};
            data = data || {};
            const chatId = that.readCookie('chat-id');
            datat.chat_id = chatId;

            networkHelper.postJSON(_core.getEmbedApiBase() + '/bot-check-availability/' + chatId, data).then(callback);
        }

        let $scrollDownButtonElement;
        this.showScrollDownButton = function (display) {
            if (display && !$scrollDownButtonElement) {
                $scrollDownButtonElement = domHelper('section#templates #template-scroll-down > *').clone();
                $scrollDownButtonElement.appendTo('#chat-conversation');
            }
            if (!display && $scrollDownButtonElement) {
                $scrollDownButtonElement.remove();
                $scrollDownButtonElement = undefined;
                that.resetScrollDownLastMessageCount();
            }
        }

        this.scrollToLastMessage = function (isButtonClicked) {
            const $chatConversation = domHelper('#chat-conversation');
            let top = $chatConversation[0].scrollHeight;

            const $quickReplies = $chatConversation.find('.quick-replies');

            if (!isButtonClicked) {
                if ($quickReplies[0]?.previousSibling) {
                    top = $quickReplies[0].previousSibling.offsetTop - 10;
                }
            }

            const scroll = () => $chatConversation[0].scrollTo({
                top: top,
                behavior: 'smooth'
            });
            scroll();
            domHelper($chatConversation).find('img').once('load', scroll);
        }

        this.resetScrollDownLastMessageCount = function() {
            that.updateCookie('unread', 0);
            domHelper('.scroll-down-button')
                .attr('data-unread-count', 0)
                .removeClass('new_message_count');
        }

        function intializeUploader() {
            if (typeof _uploader !== "undefined") {
                _uploader?.removeListener();
                _uploader = undefined;
            }

            const btn = domHelper("#send-photo-button");

            if (typeof _uploader === "undefined" && btn.length) {
                _uploader = new rp.chat.ChatUpload({
                    name: 'imgfile',
                    chatId: that.readCookie('chat-id'),
                    url: _core.getEmbedApiBase() + '/file-upload',
                    button: '#send-photo-button',
                    progressBar: "#upload-progress-wrap",
                    maxSize: 12000000,
                    allowedExtensions: [
                        'jpg',
                        'jpeg',
                        'png',
                        'gif',
                        'mov',
                        'mp4',
                        'ogg',
                        'pdf'
                    ],
                    onSizeError: function() {
                        that.processSystemNotice({ text: window.rp.layer2_lang.FILE_TOO_LARGE, timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset() });
                    },
                    onExtError: function() {
                        that.processSystemNotice({ text: window.rp.layer2_lang.FILE_TYPE_NOT_ALLOWED, timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset() });
                    },
                    onProgress100: function() {
                        that.processSystemNotice({ text: window.rp.layer2_lang.FILE_CHECKING_FILE, timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset() });
                        that.scrollToLastMessage();
                    },
                    onComplete: function(response) {
                        if (!response) {
                            that.processSystemNotice({ text: window.rp.layer2_lang.FILE_UPLOAD_FAILED, timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset() });
                        }
                        if (response.success === true) {
                            that.processSystemNotice({ text: window.rp.layer2_lang.FILE_SUCCESS, timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset() });

                            let html;

                            switch (true) {
                                case /image\/(.*)/.test(response.type):
                                    html = '<a href="' + encodeURI(response.url) + '" target="_blank" data-target="#photoUploadImageModal"><img src="' + encodeURI(response.url) + '" class="img-responsive img-thumbnail" alt=""></a>';
                                    break;

                                case /video\/(.*)/.test(response.type):
                                    html = '<video src="' + encodeURI(response.url) + '" class="img-responsive img-thumbnail" controls autobuffer></video>';
                                    break;

                                default:
                                    const el = document.createElement('a');
                                    el.href = response.url;
                                    el.target = '_blank';
                                    el.download = response.file;
                                    el.innerText = response.file;
                                    html = el.outerHTML;
                            }

                            let data = {
                                name: _customerName,
                                timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset(),
                                raw: true,
                                text: html,
                                dept_id: _deptId,
                                message_id: generateUniqueId()
                            };

                            _clientChat.sendMessage({type: 'customer-message', payload: data});

                            let chatId = that.readCookie('chat-id');
                            data.chat_id = chatId;

                            networkHelper.postJSON(_core.getEmbedApiBase() + '/send-message/' + chatId, data).then((data) => {
								that.processOutgoingMessage(data);
                            });
                        } else {
                            if (response.msg) {
                                that.processSystemNotice({ text: response.msg, timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset() });
                            } else {
                                that.processSystemNotice({ text: window.rp.layer2_lang.FILE_UPLOAD_FAILED, timestamp: Math.floor(new Date / 1000) + rp.chat.Core.getTimeOffset() });
                            }
                        }
                    }
                });
            }
        }

        this.setLayer = function(invitetype, kind, businessRuleId) {
            _invitetype = invitetype || _invitetype;
            _businessRuleId = businessRuleId || _businessRuleId;
            firstPositionSet = false;
            const left = that.readCookie('left');
            const top = that.readCookie('top');
            that.setChatPosition(_chatWrapper, left, top);

            intializeUploader();

            if (that.readCookie('closed') === true) {
                that.updateInitialUrl();
            }

            if (this.canStoreCookies() === false) {
                this.showChat('cookie');
                return;
            }

            if (kind === 'video') {
                that.updateCookie('chime', 'full');
            }

            networkHelper.getJSON(_core.getEmbedApiBase() + '/ischatting').then ((data) => {
                (async function (data) {
				if (typeof _clientChat === 'undefined') {
					await that.initMQTT();
					if (data.is_chatting == true) {
						await _clientChat.startChat(data.chat_id);
					}
				}
                if (window.io === undefined) {
                    networkHelper.loadScript(_socketServerUrl).then (() => {
                        that.initSocket();
                    });
                } else {
                    that.initSocket();
                }

                let content = that.readCookie('window');

                if ((!_isRunning) && (data.is_chatting == true || that.readCookie('chat-id')) && content !== "postchat") {
                    that.updateCookie('chat-id', data.chat_id);
                    that.updateCookie('closed', false);
                    triggerEvent(document, 'rp-chat-running');

                    _requestId = data.request_id;

                    if (data.identity !== undefined) {
                        content = content === "search-reply" ? "search-reply" : "chat";
                        that.processAgentIdentity(data.identity);
                    }

                    if (that.readCookie('isRouting') || data.identity === undefined) {
                        that.runRequestStateWorker();
                        that.showChat(content);
                        triggerEvent(document, 'rp-layer-opened');
                        _isRunning = true;
                        return;
                    }

                    that.showChat(content, async function() {
                        // reset potential queued messages already loaded upon re-init
                        _operatorMessageTimeouts.forEach(timeout => clearTimeout(timeout));
                        _operatorMessageTimeouts = [];

                        if (typeof _clientChat === "undefined") {
                            await _clientChat.startChat( data.chat_id);
                        }

                        that.processTranscriptEvents(data.events);

                        that.ping({
                            chat_id: data.chat_id,
                        });
                        _customerName = data.name;
                        _requestId = data.request_id;

                        if (data.quick_replies && data.quick_replies.length) {
                            that.processQuickReplies(data.quick_replies, data.quick_replies_type);
                        }
                        if (data.search_replies?.searchList?.length) {
                            that.botSearchReply = data.search_replies;
                            that.processSearchReply({searchList: data.search_replies.searchList});
                        }

						if (that.readCookie('botDataPrivacy')) {
							triggerEvent(document, 'rp-bot-show-data-privacy', that.readCookie('botDataPrivacy'));
							that.updateCookie('botDataPrivacy', null);
						}

                        if (that.readCookie('show-rating-active')) {
                            triggerEvent(document, 'rp-bot-show-rating', that.readCookie('show-rating-active'));
                        }

                        that.scrollToLastMessage();
						that.bindScrollEvents();
						that.resetScrollDownLastMessageCount();
                        that.updateCookie('isRouting', false);

                        if (!_chatWrapper.find('.chat-body').isVisible()) {
                            const unread = that.readCookie('unread');
                            triggerEvent(document, 'rp-unread-messages', {
                                count: unread
                            });
                        }

                        if (that.readCookie('datasecurity') !== undefined) {
                            domHelper('.js-accept-datasecurity').closest('div').addClass('hidden');
                        }
                        triggerEvent(document, 'rp-layer-opened');
                        _isRunning = true;
                    });
                } else if (_isRunning && _reloadChatContent && (content === "chat" || content === "search-reply")) {
                    document.getElementById('chat-conversation').innerHTML = '';
                    that.processTranscriptEvents(data.events);
                    if (data.quick_replies && data.quick_replies.length) {
                        that.processQuickReplies(data.quick_replies, data.quick_replies_type);
                    }
                    if (that.botSearchReply?.searchList?.length) {
                        const searchInputField = _chatWrapper.find('#search-reply-input')[0];
                        const searchValue = searchInputField ? searchInputField.value : '';

                        if (searchValue && searchValue.trim() !== '') {
                            const eventDetail = {
                                target: {
                                    value: searchValue
                                }
                            };
                            triggerEvent(document, 'rp-search-reply-input', eventDetail);
                        } else {
                            if (that.botSearchReply?.searchList?.length) {
                               that.processSearchReply({searchList: that.botSearchReply.searchList});
                            }
                        }
                    }
                    if (typeof that.readCookie('datasecurity') !== 'undefined') {
                        domHelper('.js-accept-datasecurity').closest('div').addClass('hidden');
                    }
                    if (data.identity !== undefined) {
                        that.processAgentIdentity(data.identity);
                    }
                    _reloadChatContent = false;
                } else {
                    if (that.readCookie('closed') == false && (content === 'prechat' || content === 'contact' || content === 'hotline')) {
						that.showChat(content);
						triggerEvent(document, 'rp-layer-opened');
						_isRunning = true;
					} else if (content === 'prechat' || content === 'contact' || content === 'hotline' || (content === 'routing' && !data.is_chatting)) {
                        networkHelper.getJSON(_core.getEmbedApiBase() + '/availability/' + kind + '/' + _deptId).then((data) => {

                            if (rpChatConfig.mobileLink !== undefined && rpChatConfig.mobileLink.active !== undefined && rpChatConfig.mobileLink.active) {
                                _config.prechatEnabled = false;
                                data.available = true;
                            }
                            if (data.available == false) {
                                that.resetForm(_emailFormId);
                                that.showChat(_config.offlineWindow, function () {
                                    if (content !== 'contact' && content !== 'hotline') {
                                        that.saveContentViews(_config.offlineWindow === 'contact' ? 'status_button_contact_max_capacity' : 'status_button_hotline_max_capacity');
                                    }
                                    triggerEvent(document, 'rp-layer-opened');
                                    _isRunning = true;
                                });
                                return;
                            }

                            that.showChat(_config.prechatEnabled ? 'prechat' : 'routing', function () {
                                if (!_config.prechatEnabled) {
                                    that.saveContentViews('disabled_prechat');
									_isRouting = false;
									that.startRouting();
                                    that.runRequestStateWorker();
                                } else {
                                    if (_config.prechatEnabled && _statusButtonUsed && content === 'prechat') {
                                        that.saveContentViews('status_button_prechat');
                                    }
                                }
                                triggerEvent(document, 'rp-layer-opened');
                                _isRunning = true;
                            });
                        });
                    } else {
                        if (content === 'postchat') {
                            if (that.readCookie('chat-id')) {
								if (data.identity !== undefined) {
									_agentIdentity = data.identity;
								}
                            } else {
                                content = 'prechat';
                            }
                        }

						// add transcript if content is empty
						if (content === 'chat' && document.querySelector('#chat-conversation').children.length === 0) {
							that.processTranscriptEvents(data.events);

							if (data.identity !== undefined) {
								that.processAgentIdentity(data.identity);
							}
						}

                        that.showChat(content, function() {
                            if (content === 'prechat' && !_config.prechatEnabled) {
                                that.startRouting();
                            }
                            triggerEvent(document, 'rp-layer-opened');
                        });
                    }
                }
            })(data);
			});
        };

        this.showChat = function(content, callback) {
            if (content === undefined) {
                content = 'prechat';
            }

            that.updateCookie('closed', false);

            that.showContent(content, true);

            _chatWrapper
                .each(el => el.style.display = 'flex')
                .removeClass('closed')
                .fadeIn(_fadeInTime);

            if (typeof callback === 'function') {
                callback();
            }
        };

        this.hideChat = function(callback) {
            _chatWrapper.fadeOut(_fadeOutTime, function() {
                _chatWrapper.addClass('closed');
                that.updateCookie('closed', true);
            });

            if (typeof callback === 'function') {
                callback();
            }
        };

        this.resizeChat = function () {
			_chatWrapper.attr('style', 'width:600px; resize:both; min-width:360px; min-height:600px; overflow: auto');
		}

        this.swapMessageBoxForPdfButton = function() {
            if (domHelper('#' + _chatWrapperId).find('section#chat .footer div#chat-pdf-button').length !== 0) {
                domHelper('#' + _chatWrapperId).find('section#chat .footer #inputarea').addClass('hidden');
                domHelper('#' + _chatWrapperId).find('section#chat .footer div#chat-pdf-button').removeClass('hidden');
            }
        }

        this.swapPdfButtonForMessageBox = function() {
            if (domHelper('#' + _chatWrapperId).find('section#chat .footer div#chat-pdf-button').length !== 0) {
                domHelper('#' + _chatWrapperId).find('section#chat .footer #inputarea').removeClass('hidden');
                domHelper('#' + _chatWrapperId).find('section#chat .footer div#chat-pdf-button').addClass('hidden');

            }
        }

        this.updateInitialUrl = function() {
            let url = rp.chat.Core.getCurrentUrl();
            if (
                rpChatConfig.isInternal && rpChatConfig.isInternal === true
                && typeof rpChatInitialUrl !== 'undefined'
            ) {
                url = rpChatInitialUrl;
            }
            this.updateCookie('initialUrl', url);
        }

		this.initMQTT = async function() {
			if (typeof _clientChat === "undefined") {
				const mqttBaseUrl = rp.chat.Core.getConfig().baseUrlMqttWs;
				const config = {
					apiBaseUrl: _dialogUrl.replace(/\/system/, '') + '/mqtt-api',
					mqttBaseUrl: mqttBaseUrl !== ''
						? ('wss://' + mqttBaseUrl)
						: _dialogUrl.replace(/\/system/, '').replace(/^https/, 'wss') + '/mqtt/ws',
				};
				_clientChat = new mqttChatClient.UserChatClient(config);

                that.bindMQTTEvents();
		    }
		};

        this.initSocket = function() {
            if (_socket === undefined) {
				const _socketUrl = /^https?:\/\/[^\/]+/.exec(_socketServerUrl)[0];
				_socket = window.io(_socketUrl + '/chat', {
					path: '/socket/socket.io',
					transports: ['websocket', 'polling']
				});

                _socket.on("connect_error", () => {
                    _socket.io.opts.transports = ["polling", "websocket"];
                });

				that.bindSocketEvents();
			}
        };

        /**
         * extern (loadchatmodule.js)
         */
        this.createLayer = function(callback) {
            if (rp.chat.Core.getSessionRp() !== '') {
                _visitorId = escape(rp.chat.Core.getSessionRp());
            }
            if (_chatWrapper === undefined) {
                try {
                    if (!window.rpChatConfig.containerSelector) {
                        const chatWrapper = document.createElement('div');
                        chatWrapper.id = _chatWrapperId;

                        _chatWrapper = domHelper(chatWrapper);

                        if (_config.isMobile) {
                            _chatWrapper.addClass('mobile');
                        }
                    } else {
                        _chatWrapper = domHelper(rpChatConfig.containerSelector);
                    }
                    if (that.readCookie('minimized')) {
                        _chatWrapper.addClass('minimized');
                    }
                    if (that.readCookie('dept-id')) {
                        _deptId = that.readCookie('dept-id');
                    }

                    _chatWrapper.addClass('closed');

                    if (domHelper('#' + _chatWrapperId).length === 0) {
                        let layerCssLoaded, layerJsMqttLoaded = false;

                        networkHelper.loadScript(versionizeUrl(_collectUrl + '/../assets/js/mqtt.js')).then(() => {
                            layerJsMqttLoaded = true;
                        });

                        networkHelper.loadStyle(versionizeUrl(_collectUrl + '/layouts/' + _config.theme +'/css/layer2.css')).then(() => {
                            layerCssLoaded = true;
                        });

                        if (rp.chat.Core.getConfig().chatContainer !== undefined
                            && !_config.isMobile
                            && domHelper(rp.chat.Core.getConfig().chatContainer).length
                        ) {
                            if (rp.chat.Core.getConfig().disableDragging !== undefined) {
                                window.rpChatConfig.disableDragging = rp.chat.Core.getConfig().disableDragging;
                            }
                            domHelper(rp.chat.Core.getConfig().chatContainer).append(_chatWrapper);
                        } else if (!window.rpChatConfig.containerSelector) {
                            _body.append(_chatWrapper);
                        }

                        if (!that.readCookie('closed')
                            && (
                                rp.chat.LayerChat.readCookie('chat-id') !== 0
                                || !rp.chat.Core.getConfig().department_capacity
                                || rp.chat.Core.getConfig().department_capacity > 0
                            )
                        ) {
                            _chatWrapper.removeClass('closed');
                        }

                        _chatWrapper.on('click', '[data-chat-event]:not([data-chat-event-type]),[data-chat-event][data-chat-event-type="click"]', function(e) {
                            e.preventDefault();
                            const $this = domHelper(this);
                            const event = $this.data('chat-event');
                            triggerEvent(e.currentTarget, event, e);
                        });

                        _chatWrapper.on('change', '[data-chat-event][data-chat-event-type="change"]', function(e) {
                            const $this = domHelper(this);
                            const event = $this.data('chat-event');
                            triggerEvent(e.currentTarget, event, e);
                            if (this.type === 'checkbox' && !this.checked) {
                                rp.chat.Storage.set(that.readCookie('window'), $this.attr('name'), "0");
                            } else {
                                rp.chat.Storage.set(that.readCookie('window'), $this.attr('name'), $this.val());
                            }
                        });

                        _chatWrapper.on('keyup', '[data-chat-event][data-chat-event-type="keyup"]', function(e) {
                            const $this = domHelper(this);
                            const event = $this.data('chat-event');
                            triggerEvent(e.currentTarget, event, e);
                            rp.chat.Storage.set(that.readCookie('window'), $this.attr('name'), $this.val());
                        });

                        // _chatWrapper.on('keyup', '[data-chat-event][data-chat-event-type="keypress"]', function(e) {
                        //     const $this = domHelper(this);
                        //     const event = $this.data('chat-event');
                        //     triggerEvent(e.currentTarget, event, e);
                        //     rp.chat.Storage.set(that.readCookie('window'), $this.attr('name'), $this.val());
                        // });
                        //
                        _chatWrapper.on('input', '[data-chat-event][data-chat-event-type="keypress"]', function(e) {
                            const $this = domHelper(this);
                            const event = $this.data('chat-event');
                            triggerEvent(e.currentTarget, event, e);
                            rp.chat.Storage.set(that.readCookie('window'), $this.attr('name'), $this.val());
                        });

                        _chatWrapper.on('keydown', '[data-chat-event][data-chat-event-type="keydown"]', function(e) {
                            const $this = domHelper(this);
                            const event = $this.data('chat-event');
                            triggerEvent(e.currentTarget, event, e);
                        });

                        _chatWrapper.on('keyup', '[data-chat-event][data-chat-event-type="keypress"]', function(e) {
                            const $this = domHelper(this);
                            const event = $this.data('chat-event');
                            triggerEvent(document, event, e);
                            rp.chat.Storage.set(that.readCookie('window'), $this.attr('name'), $this.val());
                        });

                        _chatWrapper.on('submit submitForm', '[data-chat-event][data-chat-event-type="submit"]', function(e) {
                            e.preventDefault();
                            const $this = domHelper(this);
                            const event = $this.data('chat-event');
                            triggerEvent(e.currentTarget, event, e);
                            rp.chat.Storage.remove(that.readCookie('window'), $this.attr('name'));
                        });

						const awaitLayerDependencies = function () {
							if (!(layerCssLoaded && layerJsMqttLoaded)) {
								setTimeout(awaitLayerDependencies, 10);
								return;
							}

                            if (that.readCookie('closed') == false) {
                                if (rp.chat.LayerChat.readCookie('chat-id') !== 0 || !rp.chat.Core.getConfig().department_capacity || rp.chat.Core.getConfig().department_capacity > 0) {
                                    that.initLayerContent(function () {
                                        const kind = that.readCookie('chime') === 'full' ? 'video' : 'text';
                                        that.setLayer(0, kind);

                                        if (typeof callback === "function") {
                                            callback();
                                        }
                                    });
                                }
                            } else {
                                callback();
                            }

                            triggerEvent(document, 'rp-layer-created');
                        };
                        awaitLayerDependencies();
                    }

                } catch(e) {
                    console.log(e);
                }
            } else {

            }
        };

        let lastInitDeptId;
        let contentData = {};
        this.initLayerContent = function (callback) {
            _deptId = rp.chat.Core.getDeptId();
            if (_chatWrapper === undefined) {
                rp.chat.LayerChat.createLayer(callback);
            } else {
                if (lastInitDeptId != _deptId) {
                    lastInitDeptId = _deptId;
                    if (that.readCookie('dept-id')) {
                        _deptId = that.readCookie('dept-id');
                    }

                    networkHelper.getJSON(_core.getEmbedApiBase() + '/load-content/' + _deptId).then((data) => {
                        contentData = data;

                        networkHelper.loadText(_collectUrl + '/layouts/' + rp.chat.Core.getConfig().theme + '/html/index.html').then((data) => {
                            const shadow = document.createElement('div');
                            shadow.innerHTML = data;

                            let disableToSendMessages = false;
                            if (document.querySelector('#' + _chatWrapperId + ' #send_button') !== null) {
                                if (document.querySelector('#' + _chatWrapperId + ' #send_button').disabled == true) {
                                    disableToSendMessages = true;
                                }
                            }
                            if (document.querySelector('#' + _chatWrapperId + ' #message') !== null) {
                                if (document.querySelector('#' + _chatWrapperId + ' #message').disabled == true) {
                                    disableToSendMessages = true;
                                }
                            }
                            processTemplate(
                                shadow,
                                _collectUrl + '/layouts/' + rp.chat.Core.getConfig().theme,
                                contentData.language,
                                contentData.features,
                                contentData.infoBlocks,
                                contentData.prechatFields,
                                contentData.contactFields,
                                contentData.survey
                            );
                            that.reloadLanguages();
                            _chatWrapper.html(shadow.innerHTML);

                            addDynamicInputFields(contentData.prechatFields, '#realpersonPreChatDynamicInputPrototype');
                            addDynamicInputFields(contentData.contactFields, '#realpersonContactDynamicInputPrototype');

                            if (document.querySelector('#' + _chatWrapperId + ' #send_button') !== null) {
                                document.querySelector('#' + _chatWrapperId + ' #send_button').disabled = disableToSendMessages;
                            }
                            if (document.querySelector('#' + _chatWrapperId + ' #message') !== null) {
                                document.querySelector('#' + _chatWrapperId + ' #message').disabled = disableToSendMessages;
                            }

                            const wrapperRect = _chatWrapper.getBoundingClientRect();
                            _chatWrapperHeight = wrapperRect.height;
                            _chatWrapperWidth = wrapperRect.width;

                            const left = that.readCookie('left');
                            const top = that.readCookie('top');

                            if (_chatWrapper.find('.drag-handle').length && !window.rpChatConfig.disableDragging) {
                                that.registerDragAndDrop();
                                that.setChatPosition(_chatWrapper, left, top);
                                _chatWrapper.removeClass('no-drag-and-drop');
                            } else {
                                _chatWrapper.addClass('no-drag-and-drop');
                            }

                            if (typeof callback === "function") {
                                callback();
                            }
                        });
                    });
                } else {
                    if (typeof callback === "function") {
                        callback();
                    }
                }
            }
        };

        function addDynamicInputFields(displayChatFields, targetElement) {
            if (displayChatFields.dynamic_input) {
                const prototype = document.querySelector(targetElement);
                if (prototype) {
                    displayChatFields.dynamic_input.forEach(elem => {
                        const newInputName = 'dynamic_input[' + elem.name + ']';

                        const form = prototype.closest('form');
                        if (form && form.querySelector(`[name='${newInputName}']`) !== null) {
                            return;
                        }

                        let newInput = prototype.cloneNode(true);
                        if (elem.type !== 'hidden') {
                            newInput.classList.remove('hidden');
                        }
                        newInput.id = '';

                        let label = newInput.getElementsByTagName('label')[0];
                        let input = newInput.getElementsByTagName('input')[0];

                        if (label.getElementsByTagName('span').length) {
                            label = label.getElementsByTagName('span')[0];
                        }

                        label.setAttribute('name', elem.uuid);
                        label.innerHTML = elem.label;

                        input.setAttribute('name', newInputName);
                        input.setAttribute('placeholder', elem.placeholder);
                        input.setAttribute('aria-labelledby', elem.uuid);

                        if (elem.type !== 'hidden') {
                            input.setAttribute('data-chat-validation', elem.validation);
                        }

                        if (elem.required && elem.type !== 'hidden') {
                            newInput.getElementsByTagName('label')[0].classList.add('required');
                            newInput.getElementsByTagName('label')[0].classList.remove('optional');

                            label.classList.add('required');
                            input.required = true;
                            input.ariaRequired = true;

                            if (newInput.getElementsByTagName('label')[0].getElementsByTagName('span').length) {
                                newInput.getElementsByTagName('label')[0].getElementsByTagName('span')[1].classList.add('hidden');
                            }
                        }

                        if (elem.errorMessage !== '') {
                            let errorMessage = newInput.querySelector('.validation-error');
                            errorMessage.innerHTML = elem.errorMessage;
                        }

                        prototype.after(newInput);
                    });
                }
            }
        }function processTemplate(
            template,
            themeBaseUri,
            language,
            features,
            infoBlocks,
            prechatFields,
            contactFields,
            survey
        ) {
            function looseJsonParse(data) {
                try {
                    return (new Function(
                        'language',
                        'features',
                        'infoBlocks',
                        'prechatFields',
                        'contactFields',
                        'survey',
                        '"use strict"; return (' + data + ');'
                    ))(
                        language,
                        features,
                        infoBlocks,
                        prechatFields,
                        contactFields,
                        survey
                    );
                } catch (e) {
                    return undefined;
                }
            }

            function getProperty(index) {
                return looseJsonParse(index);
            }

            function getLang(index) {
                let path = index.split('::');
                try {
                    let obj = language;
                    while (path.length > 0) {
                        obj = obj[path.shift()];
                    }
                    if (obj === undefined) {
                        if (rp.chat.Core.isDebugLogEnable()) {
                            console.log('missing translation: ' + index);
                        }
                        return index;
                    }
                    return obj;
                } catch (e) {
                    return index;
                }
            }

            const processDom = function (node) {
                const cleanup = true;

                while (node) {
                    let nextNode = node.nextSibling;

                    if (node.nodeType === Node.ELEMENT_NODE && template.contains(node)) {
                        const nodeAttributes = node.cloneNode(false).attributes;
                        for (let i = 0; i < nodeAttributes.length; i++) {
                            let nodeAttr = nodeAttributes[i];

                            // process rp-if attributes
                            if (nodeAttr.name === 'rp-if') {
                                if (!looseJsonParse(node.getAttribute('rp-if'))) {
                                    node.parentNode.removeChild(node);
                                    break;
                                }
                                cleanup && node.removeAttribute('rp-if');
                                continue;
                            }

                            // process rp-for attributes
                            if (nodeAttr.name === 'rp-for') {
                                const parentNode = node.parentNode;
                                const listName = node.getAttribute('rp-for');
                                const listKey = node.getAttribute('rp-for-key');
                                const listKeyRegExp = new RegExp('\\b' + listKey + '\\b', 'g');
                                const list = looseJsonParse(listName);
                                if (!list) continue;
                                list.forEach((val, index) => list[index]._index = index);

                                const repeatNodes = [];
                                for (let j = 0; j < list.length; j++) {
                                    const cloneNode = node.cloneNode(true);
                                    cloneNode.removeAttribute('rp-for');
                                    cloneNode.removeAttribute('rp-for-key');
                                    if (listKey) {
                                        const updateKeys = function (updateNode) {
                                            while (updateNode) {
                                                if (updateNode.nodeType === Node.ELEMENT_NODE) {
                                                    for (let k = 0; k < updateNode.attributes.length; k++) {
                                                        let updateAttr = updateNode.attributes[k];
                                                        if (/^rp-/.test(updateAttr.name)) {
                                                            // only replace parts that are not strings
                                                            const tokens = updateAttr.value.split('+');
                                                            for (let t = 0; t < tokens.length; t++) {
                                                                if (/^\s*['"][^'"]*['"]\s*$/.test(tokens[t])) {
                                                                    continue;
                                                                }
                                                                tokens[t] = tokens[t].replace(listKeyRegExp, listName + '[' + j + ']');
                                                            }
                                                            updateNode.setAttribute(updateAttr.name, tokens.join('+'));
                                                        }
                                                    }
                                                    updateKeys(updateNode.firstChild);
                                                }
                                                updateNode = updateNode.nextSibling;
                                            }
                                        }
                                        updateKeys(cloneNode);
                                    }

                                    if (node.nodeName === 'RP-REPEAT') {
                                        repeatNodes.push(cloneNode);
                                    } else {
                                        parentNode.appendChild(cloneNode);
                                    }
                                }

                                parentNode.removeChild(node);

                                if (repeatNodes.length > 0) {
                                    repeatNodes.forEach((repeatNode) => {
                                        repeatNode.childNodes.forEach((childNode) => {
                                            parentNode.appendChild(childNode.cloneNode());
                                        });
                                    });
                                }

                                cleanup && node.removeAttribute('rp-for');
                                cleanup && node.removeAttribute('rp-for-key');
                                continue;
                            }

                            // process rp-lang-* attributes
                            let matchLangAttr = nodeAttr.name.match(/^rp-lang-(.*)$/);
                            if (matchLangAttr) {
                                let attrName = matchLangAttr[1];
                                try {
                                    switch (attrName) {
                                        case 'html':
                                            node.innerHTML = getLang(node.getAttribute(nodeAttr.name));
                                            break;
                                        case 'text':
                                            node.innerText = getLang(node.getAttribute(nodeAttr.name));
                                            break;
                                        case 'placeholder':
                                            const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
                                            if (!isIE11) {
                                                node.placeholder = getLang(node.getAttribute(nodeAttr.name));
                                            }
                                            break;
                                        default:
                                            node.setAttribute(attrName, getLang(node.getAttribute(nodeAttr.name)));
                                    }
                                } catch (e) {
                                }
                                cleanup && node.removeAttribute(nodeAttr.name);
                                continue;
                            }

                            // process rp-val-* attributes
                            let matchValAttr = nodeAttr.name.match(/^rp-val-(.*)$/);
                            if (matchValAttr) {
                                let attrName = matchValAttr[1];
                                try {
                                    switch (attrName) {
                                        case 'html':
                                            node.innerHTML = getProperty(node.getAttribute(nodeAttr.name));
                                            break;
                                        case 'text':
                                            node.innerText = getProperty(node.getAttribute(nodeAttr.name));
                                            break;
                                        default:
                                            node.setAttribute(attrName, getProperty(node.getAttribute(nodeAttr.name)));
                                    }
                                } catch (e) {
                                }
                                cleanup && node.removeAttribute(nodeAttr.name);
                                continue;
                            }

                            // process rp-theme-* attributes
                            let matchThemeAttr = nodeAttr.name.match(/^rp-theme-(.*)$/);
                            if (matchThemeAttr) {
                                let attrName = matchThemeAttr[1];
                                try {
                                    node.setAttribute(attrName, themeBaseUri +  '/' + node.getAttribute(nodeAttr.name));
                                } catch (e) {
                                }
                                cleanup && node.removeAttribute(nodeAttr.name);
                                continue;
                            }

                            // process rp-class attributes
                            if (nodeAttr.name === 'rp-class') {
                                try {
                                    const checks = looseJsonParse(node.getAttribute('rp-class'));
                                    if (checks) {
                                        const names = Object.keys(checks);
                                        for (let j = 0; j < names.length; j++) {
                                            if (checks[names[j]]) {
                                                node.classList.add(names[j]);
                                            }
                                        }
                                    }
                                } catch (e) {
                                }
                                cleanup && node.removeAttribute('rp-class');
                                continue;
                            }

                            // no further attributes
                        }
                        processDom(node.firstChild);
                    }
                    node = nextNode;
                }
            };
            processDom(template);

            // set old language
            window.rp = window.rp || {};
            window.rp.layer2_lang = window.rp.layer2_lang || {};
            window.rp.layer2_lang.CHAT_PARTYLEFTSESSION_AGENT = getLang('index::agent-left-session');
            window.rp.layer2_lang.CHAT_PARTYLEFTSESSION_TIMEOUT = getLang('index::session-timeout-agent');
            window.rp.layer2_lang.CHAT_PARTYLEFTSESSION_IDLE = getLang('index::session-inactive');
            window.rp.layer2_lang.IS_TYPING = getLang('index::is-typing');
            window.rp.layer2_lang.CUSTOMER = getLang('index::placeholder-name');
            window.rp.layer2_lang.FILE_TOO_LARGE = getLang('index::file-upload::file-too-large');
            window.rp.layer2_lang.FILE_TYPE_NOT_ALLOWED = getLang('index::file-upload::file-type-not-allowed');
            window.rp.layer2_lang.FILE_UPLOAD_FAILED = getLang('index::file-upload::upload-failed');
            window.rp.layer2_lang.FILE_CHECKING_FILE = getLang('index::file-upload::checking-file');
            window.rp.layer2_lang.FILE_SUCCESS = getLang('index::file-upload::success');
            window.rp.layer2_lang.COBROWSING_USER_ACCEPT = getLang('cobrowsing::cobrowsing-transcript-caption-user-accept');
            window.rp.layer2_lang.COBROWSING_ACCEPT_WAIT = getLang('cobrowsing::cobrowsing-moment-wait');
            window.rp.layer2_lang.COBROWSING_CLOSE_BY_CUSTOMER = getLang('cobrowsing::close-by-customer');
            window.rp.layer2_lang.DATASECURITY_ACCEPT_RESPONSE = getLang('data-privacy::accept-response');
            window.rp.layer2_lang.DATASECURITY_DENY_RESPONSE = getLang('data-privacy::deny-response');
            window.rp.layer2_lang.FILE_UPLOAD_TITLE = getLang('chat::file-upload');
            window.rp.layer2_lang.MESSAGE_WAS_NOT_DELIVERED = getLang('index::socket::message-was-not-delivered');
            window.rp.layer2_lang.SCREENSHARE_ACCEPT_WAIT = getLang('screenshare::screenshare-moment-wait');
            window.rp.layer2_lang.VOICE_ACCEPT_WAIT = getLang('voice::voice-moment-wait');
            window.rp.layer2_lang.VOICE_ENDED = getLang('voice::voice-ended');
            window.rp.layer2_lang.TRANSLATED = getLang('chat::translated');
        }

        /**
         * intern
         */
        var triggerEvent = function (el, type, payload) {
            const e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, true, true, payload);
            el.dispatchEvent(e);
        };

        var setSaveTranscript = function (saveFlag) {
            if (that.readCookie('chat-id') > 0) {
                const data = {
                    chat_id: that.readCookie('chat-id'),
                    datasecurity: saveFlag,
					profile_id: _agentIdentity.id,
                    request_id: _requestId
                };

                networkHelper.postJSON(_core.getEmbedApiBase() + '/save-datasecurity/' + _deptId, data);
            }
        }

        var removeHTML = function(text) {
            const tmp = document.createElement("div");
            tmp.innerHTML = text;
            return tmp.textContent || tmp.innerText || "";
        }
    }
};

//# sourceURL=loadlayerchatmodul-v2.js
